import React from "react";

const Facebook = () => {
  return (
    <svg
      fill="#000000"
      width="800px"
      height="800px"
      viewBox="0 0 24 24"
      id="facebook"
      className="icon flat-color"
    >
      <path
        id="primary"
        d="M14,6h3a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H14A5,5,0,0,0,9,7v3H7a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1H9v7a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V14h2.22a1,1,0,0,0,1-.76l.5-2a1,1,0,0,0-1-1.24H13V7A1,1,0,0,1,14,6Z"
      ></path>
    </svg>
  );
};

const InstagramVector = () => {
  return (
    <svg width="800px" height="800px" viewBox="0 0 20 20" version="1.1">
      <defs></defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Dribbble-Light-Preview"
          transform="translate(-340.000000, -7439.000000)"
          fill="#000000"
        >
          <g id="icons" transform="translate(56.000000, 160.000000)">
            <path
              d="M289.869652,7279.12273 C288.241769,7279.19618 286.830805,7279.5942 285.691486,7280.72871 C284.548187,7281.86918 284.155147,7283.28558 284.081514,7284.89653 C284.035742,7285.90201 283.768077,7293.49818 284.544207,7295.49028 C285.067597,7296.83422 286.098457,7297.86749 287.454694,7298.39256 C288.087538,7298.63872 288.809936,7298.80547 289.869652,7298.85411 C298.730467,7299.25511 302.015089,7299.03674 303.400182,7295.49028 C303.645956,7294.859 303.815113,7294.1374 303.86188,7293.08031 C304.26686,7284.19677 303.796207,7282.27117 302.251908,7280.72871 C301.027016,7279.50685 299.5862,7278.67508 289.869652,7279.12273 M289.951245,7297.06748 C288.981083,7297.0238 288.454707,7296.86201 288.103459,7296.72603 C287.219865,7296.3826 286.556174,7295.72155 286.214876,7294.84312 C285.623823,7293.32944 285.819846,7286.14023 285.872583,7284.97693 C285.924325,7283.83745 286.155174,7282.79624 286.959165,7281.99226 C287.954203,7280.99968 289.239792,7280.51332 297.993144,7280.90837 C299.135448,7280.95998 300.179243,7281.19026 300.985224,7281.99226 C301.980262,7282.98483 302.473801,7284.28014 302.071806,7292.99991 C302.028024,7293.96767 301.865833,7294.49274 301.729513,7294.84312 C300.829003,7297.15085 298.757333,7297.47145 289.951245,7297.06748 M298.089663,7283.68956 C298.089663,7284.34665 298.623998,7284.88065 299.283709,7284.88065 C299.943419,7284.88065 300.47875,7284.34665 300.47875,7283.68956 C300.47875,7283.03248 299.943419,7282.49847 299.283709,7282.49847 C298.623998,7282.49847 298.089663,7283.03248 298.089663,7283.68956 M288.862673,7288.98792 C288.862673,7291.80286 291.150266,7294.08479 293.972194,7294.08479 C296.794123,7294.08479 299.081716,7291.80286 299.081716,7288.98792 C299.081716,7286.17298 296.794123,7283.89205 293.972194,7283.89205 C291.150266,7283.89205 288.862673,7286.17298 288.862673,7288.98792 M290.655732,7288.98792 C290.655732,7287.16159 292.140329,7285.67967 293.972194,7285.67967 C295.80406,7285.67967 297.288657,7287.16159 297.288657,7288.98792 C297.288657,7290.81525 295.80406,7292.29716 293.972194,7292.29716 C292.140329,7292.29716 290.655732,7290.81525 290.655732,7288.98792"
              id="instagram-[#167]"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

const Instagram = () => {
  return (
    <svg width={800} height={800} fill="none" viewBox="0 0 32 32">
      <rect width={28} height={28} x={2} y={2} fill="url(#a)" rx={6} />
      <rect width={28} height={28} x={2} y={2} fill="url(#b)" rx={6} />
      <rect width={28} height={28} x={2} y={2} fill="url(#c)" rx={6} />
      <path fill="#fff" d="M23 10.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M16 21a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M6 15.6c0-3.36 0-5.04.654-6.324a6 6 0 0 1 2.622-2.622C10.56 6 12.24 6 15.6 6h.8c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C26 10.56 26 12.24 26 15.6v.8c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622C21.44 26 19.76 26 16.4 26h-.8c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C6 21.44 6 19.76 6 16.4v-.8ZM15.6 8h.8c1.713 0 2.878.002 3.778.075.877.072 1.325.202 1.638.361a4 4 0 0 1 1.748 1.748c.16.313.29.761.36 1.638.074.9.076 2.065.076 3.778v.8c0 1.713-.002 2.878-.075 3.778-.072.877-.202 1.325-.361 1.638a4 4 0 0 1-1.748 1.748c-.313.16-.761.29-1.638.36-.9.074-2.065.076-3.778.076h-.8c-1.713 0-2.878-.002-3.778-.075-.877-.072-1.325-.202-1.638-.361a4 4 0 0 1-1.748-1.748c-.16-.313-.29-.761-.36-1.638C8.001 19.278 8 18.113 8 16.4v-.8c0-1.713.002-2.878.075-3.778.072-.877.202-1.325.361-1.638a4 4 0 0 1 1.748-1.748c.313-.16.761-.29 1.638-.36.9-.074 2.065-.076 3.778-.076Z"
        clipRule="evenodd"
      />
      <defs>
        <radialGradient
          id="a"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(-55.376 27.916 .066) scale(25.5196)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B13589" />
          <stop offset={0.793} stopColor="#C62F94" />
          <stop offset={1} stopColor="#8A3AC8" />
        </radialGradient>
        <radialGradient
          id="b"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(-65.136 29.766 6.89) scale(22.5942)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E0E8B7" />
          <stop offset={0.445} stopColor="#FB8A2E" />
          <stop offset={0.715} stopColor="#E2425C" />
          <stop offset={1} stopColor="#E2425C" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="c"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(38.50003 -5.5 1.1764 8.23476 .5 3)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.157} stopColor="#406ADC" />
          <stop offset={0.468} stopColor="#6A45BE" />
          <stop offset={1} stopColor="#6A45BE" stopOpacity={0} />
        </radialGradient>
      </defs>
    </svg>
  );
};

const Youtube = () => {
  return (
    <svg width={24} height={16} fill="none">
      <path
        d="M23.125 2.498A2.864 2.864 0 0 0 21.108.476C19.331 0 12.2 0 12.2 0S5.073 0 3.292.476a2.864 2.864 0 0 0-2.017 2.022C.8 4.28.8 8 .8 8s0 3.72.475 5.502a2.864 2.864 0 0 0 2.017 2.022C5.073 16 12.2 16 12.2 16s7.131 0 8.909-.476a2.863 2.863 0 0 0 2.016-2.022C23.6 11.72 23.6 8 23.6 8s0-3.72-.475-5.502Z"
        fill="#fff"
      />
      <path d="M9.922 11.43 15.845 8 9.922 4.57v6.86Z" fill="#000" />
    </svg>
  );
};

const Twitter = () => {
  return (
    <svg width={22} height={18} fill="none">
      <path
        d="M20.927 2.667a8.363 8.363 0 0 1-2.066.59c.333-.057.822-.656 1.017-.899.296-.365.521-.783.665-1.23 0-.034.033-.082 0-.105a.114.114 0 0 0-.11 0c-.772.418-1.593.737-2.445.95a.171.171 0 0 1-.171-.043 2.375 2.375 0 0 0-.214-.223 4.454 4.454 0 0 0-1.168-.756 4.105 4.105 0 0 0-1.82-.3 4.4 4.4 0 0 0-1.728.476 4.48 4.48 0 0 0-1.368 1.16 4.393 4.393 0 0 0-.83 1.664 4.572 4.572 0 0 0-.043 1.758c0 .1 0 .114-.086.1-3.386-.499-6.164-1.702-8.434-4.283-.1-.114-.152-.114-.233 0-.988 1.502-.508 3.88.727 5.053.166.157.337.31.517.452a4.238 4.238 0 0 1-1.624-.452c-.095-.062-.147-.028-.152.086a2.803 2.803 0 0 0 0 .475 4.318 4.318 0 0 0 2.66 3.442c.172.073.352.13.536.166a4.856 4.856 0 0 1-1.59.047c-.115-.023-.158.038-.115.148.698 1.901 2.213 2.481 3.325 2.804.152.024.304.024.475.062l-.029.029c-.328.599-1.653 1.003-2.26 1.212a8.12 8.12 0 0 1-3.467.446c-.186-.028-.228-.023-.276 0-.047.024 0 .076.052.124.238.157.475.295.722.428.735.401 1.513.72 2.318.95 4.17 1.15 8.862.305 11.991-2.809 2.46-2.443 3.325-5.813 3.325-9.188 0-.128.156-.204.247-.27a8.156 8.156 0 0 0 1.629-1.703.5.5 0 0 0 .114-.342c0-.071 0-.057-.09-.019Z"
        fill="#fff"
      />
    </svg>
  );
};

const WhatsApp = () => {
  return (
    <svg xmlSpace="preserve" width={800} height={800} viewBox="0 0 58 58">
      <path
        d="m0 58 4.988-14.963A28.35 28.35 0 0 1 1 28.5C1 12.76 13.76 0 29.5 0S58 12.76 58 28.5 45.24 57 29.5 57a28.373 28.373 0 0 1-13.26-3.273L0 58z"
        style={{
          fill: "#2cb742",
        }}
      />
      <path
        d="M47.683 37.985c-1.316-2.487-6.169-5.331-6.169-5.331-1.098-.626-2.423-.696-3.049.42 0 0-1.577 1.891-1.978 2.163-1.832 1.241-3.529 1.193-5.242-.52l-3.981-3.981-3.981-3.981c-1.713-1.713-1.761-3.41-.52-5.242.272-.401 2.163-1.978 2.163-1.978 1.116-.627 1.046-1.951.42-3.049 0 0-2.844-4.853-5.331-6.169a2.726 2.726 0 0 0-3.203.482l-1.758 1.758c-5.577 5.577-2.831 11.873 2.746 17.45l5.097 5.097 5.097 5.097c5.577 5.577 11.873 8.323 17.45 2.746l1.758-1.758a2.728 2.728 0 0 0 .481-3.204z"
        style={{
          fill: "#fff",
        }}
      />
    </svg>
  );
};

const Gmail = () => {
  return (
    <svg fill="none" viewBox="16 35.24 160 122.76">
      <path
        stroke="#000000"
        strokeLinejoin="round"
        strokeWidth="12"
        d="M22 57.265V142c0 5.523 4.477 10 10 10h24V95.056l40 30.278 40-30.278V152h24c5.523 0 10-4.477 10-10V57.265c0-13.233-15.15-20.746-25.684-12.736L96 81.265 47.684 44.53C37.15 36.519 22 44.032 22 57.265Z"
      ></path>
    </svg>
  );
};

const Viber = () => {
  return (
    <svg width="800px" height="800px" viewBox="0 0 32 32" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 15.3785C30 6.20699 26.7692 2 16 2C5.23077 2 2 6.20699 2 15.3785C2 21.9055 3.63629 25.9182 8.46154 27.6895V30.7774C8.46154 31.9141 9.88769 32.4332 10.6264 31.5656L13.1164 28.6411C14.0113 28.7185 14.9713 28.7569 16 28.7569C26.7692 28.7569 30 24.5499 30 15.3785ZM13.7113 26.5316C14.4251 26.5882 15.1872 26.6164 16 26.6164C25.1124 26.6164 27.8462 23.0825 27.8462 15.3785C27.8462 7.67443 25.1124 4.14055 16 4.14055C6.88757 4.14055 4.15385 7.67443 4.15385 15.3785C4.15385 20.8239 5.51965 24.1859 9.53846 25.6891V30.2639C9.53846 30.6627 10.0389 30.8449 10.2981 30.5404L13.7113 26.5316Z"
        fill="#BFC8D0"
      />
      <path
        d="M16 25.8548C15.1766 25.8548 14.4047 25.8262 13.6815 25.7685L10.224 29.845C9.96145 30.1546 9.45455 29.9693 9.45455 29.5638V24.9119C5.38354 23.3834 4 19.9647 4 14.4274C4 6.59346 6.76923 3 16 3C25.2308 3 28 6.59346 28 14.4274C28 22.2613 25.2308 25.8548 16 25.8548Z"
        fill="#9179EE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 14.3785C30 5.20699 26.7692 1 16 1C5.23077 1 2 5.20699 2 14.3785C2 20.9055 3.63629 24.9182 8.46154 26.6895V29.7774C8.46154 30.9141 9.88769 31.4332 10.6264 30.5656L13.1164 27.6411C14.0113 27.7185 14.9713 27.7569 16 27.7569C26.7692 27.7569 30 23.5499 30 14.3785ZM13.7113 25.5316C14.4251 25.5882 15.1872 25.6164 16 25.6164C25.1124 25.6164 27.8462 22.0825 27.8462 14.3785C27.8462 6.67443 25.1124 3.14055 16 3.14055C6.88757 3.14055 4.15385 6.67443 4.15385 14.3785C4.15385 19.8239 5.51965 23.1859 9.53846 24.6891V29.2639C9.53846 29.6627 10.0389 29.8449 10.2981 29.5404L13.7113 25.5316Z"
        fill="white"
      />
      <path
        d="M11.5432 12.1345L11.5026 12.157L11.4668 12.1866C11.1902 12.4154 10.7756 13.0434 11.1388 13.8197C11.4414 14.4665 12.1157 15.7874 13.3005 16.7826C14.4592 17.756 15.6965 18.2795 16.5092 18.4509L16.5603 18.4617H16.6069C16.6091 18.4619 16.614 18.4624 16.6219 18.4636C16.6412 18.4663 16.6645 18.4703 16.7012 18.4767L16.7874 17.9842L16.7012 18.4767C16.7075 18.4778 16.714 18.479 16.7208 18.4802C16.9709 18.5244 17.5704 18.6304 18.0729 18.1297C18.3954 17.8083 18.6898 17.4732 18.8165 17.3225C18.9055 17.2413 19.1956 17.0731 19.5626 17.1972C20.2576 17.4321 21.0839 17.9621 21.4833 18.2308C21.7925 18.439 22.4924 18.9404 22.8079 19.1682L22.8082 19.1684C22.8344 19.1873 22.8959 19.2493 22.9291 19.3354C22.9557 19.4042 22.97 19.4988 22.9061 19.6357C22.7875 19.8895 22.4266 20.374 21.9378 20.7978C21.4401 21.2294 20.9222 21.5 20.5072 21.5C20.5087 21.5 20.5072 21.4998 20.5025 21.4992C20.484 21.4967 20.4153 21.4874 20.2792 21.4568C20.1262 21.4225 19.9195 21.3686 19.6669 21.2926C19.1622 21.1407 18.485 20.904 17.7029 20.5675C16.1375 19.8941 14.1668 18.8277 12.3218 17.2572C11.1613 16.2694 10.0664 14.9036 9.2138 13.6251C8.35407 12.3358 7.77896 11.1932 7.62244 10.6655L7.61148 10.6285L7.595 10.5937C7.55603 10.5114 7.50112 10.3355 7.50002 10.136C7.49895 9.94333 7.54725 9.75923 7.67465 9.60657C8.09467 9.10322 8.53938 8.60859 9.52049 8.13395C9.61188 8.08974 9.75504 8.05076 9.89575 8.04849C10.04 8.04617 10.1152 8.082 10.1452 8.10835C10.5206 8.43751 11.1025 9.01857 11.4945 9.51513C11.6971 9.77164 11.9418 10.0975 12.1458 10.3806C12.2478 10.5222 12.3377 10.6506 12.4062 10.7527C12.4405 10.8039 12.4679 10.8462 12.4881 10.8788C12.5019 10.9012 12.5093 10.9143 12.5124 10.9199C12.5141 10.9256 12.5218 10.9498 12.5286 10.9939C12.5371 11.0494 12.5411 11.1177 12.5354 11.1891C12.5235 11.3351 12.4755 11.4524 12.3892 11.5315C12.0962 11.7998 11.699 12.0482 11.5432 12.1345ZM16.2766 6.51613C16.2769 6.51585 16.2772 6.51557 16.2775 6.51527C16.2847 6.50852 16.2994 6.5 16.3226 6.5C20.3145 6.5 23.4984 9.53785 23.5 13.223C23.4994 13.2239 23.4983 13.2251 23.4967 13.2267C23.4895 13.2334 23.4747 13.2419 23.4516 13.2419C23.4285 13.2419 23.4137 13.2334 23.4065 13.2267C23.4049 13.2251 23.4039 13.2239 23.4032 13.223C23.4016 9.49946 20.2032 6.53226 16.3226 6.53226C16.2994 6.53226 16.2847 6.52374 16.2775 6.51699C16.2772 6.51669 16.2769 6.5164 16.2766 6.51613ZM16.2775 10.646C16.2772 10.6457 16.2769 10.6454 16.2766 10.6452C16.2769 10.6449 16.2772 10.6446 16.2775 10.6443C16.2847 10.6376 16.2994 10.629 16.3226 10.629C17.8916 10.629 19.1113 11.8182 19.1129 13.223C19.1123 13.2239 19.1112 13.2251 19.1096 13.2267C19.1024 13.2334 19.0877 13.2419 19.0645 13.2419C19.0414 13.2419 19.0266 13.2334 19.0194 13.2267C19.0178 13.2251 19.0168 13.2239 19.0161 13.223C19.0145 11.7799 17.7803 10.6613 16.3226 10.6613C16.2994 10.6613 16.2847 10.6528 16.2775 10.646ZM16.2775 8.5815C16.2772 8.58121 16.2769 8.58092 16.2766 8.58065C16.2769 8.58037 16.2772 8.58008 16.2775 8.57979C16.2847 8.57304 16.2994 8.56452 16.3226 8.56452C19.1031 8.56452 21.3048 10.678 21.3065 13.223C21.3058 13.2239 21.3048 13.2251 21.3032 13.2267C21.296 13.2334 21.2812 13.2419 21.2581 13.2419C21.2349 13.2419 21.2201 13.2334 21.213 13.2267C21.2114 13.2251 21.2103 13.2239 21.2097 13.223C21.2081 10.6397 18.9917 8.59677 16.3226 8.59677C16.2994 8.59677 16.2847 8.58825 16.2775 8.5815Z"
        fill="white"
        stroke="white"
        strokeLinecap="round"
      />
    </svg>
  );
};
const ArrowDown = () => {
  return (
    <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none">
      <path
        d="M17 15L12 10L7 15"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Heart = () => {
  return (
    <svg width="20" height="19" viewBox="0 0 20 19" fill="none">
      <mask id="path-1-inside-1_2065_2481" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.6876 0.828735C12.6613 0.828735 10.8951 1.96999 10.0001 3.64247C9.10502 1.96996 7.34001 0.828735 5.31253 0.828735C2.3838 0.828735 0 3.21253 0 6.14127C0 12.6263 6.79629 16.7776 9.71631 18.2613H9.72998C9.8125 18.3014 9.90247 18.3288 10 18.3288C10.0975 18.3288 10.1875 18.3014 10.27 18.2613H10.2837C13.2037 16.7776 20 12.6263 20 6.14127C20 3.21253 17.6175 0.828735 14.6875 0.828735"
        />
      </mask>
      <path
        d="M10.0001 3.64247L9.11837 4.1143L10.0001 5.76188L10.8818 4.1143L10.0001 3.64247ZM9.71631 18.2613L9.2633 19.1528L9.47681 19.2613H9.71631V18.2613ZM9.72998 18.2613L10.1665 17.3616L9.95977 17.2613H9.72998V18.2613ZM10.27 18.2613V17.2613H10.0402L9.83347 17.3617L10.27 18.2613ZM10.2837 18.2613V19.2613H10.5232L10.7367 19.1528L10.2837 18.2613ZM14.6876 -0.171265C12.277 -0.171265 10.1799 1.18691 9.11837 3.17064L10.8818 4.1143C11.6102 2.75307 13.0457 1.82874 14.6876 1.82874V-0.171265ZM10.8817 3.17064C9.82021 1.187 7.72447 -0.171265 5.31253 -0.171265V1.82874C6.95555 1.82874 8.38984 2.75293 9.11837 4.1143L10.8817 3.17064ZM5.31253 -0.171265C1.83151 -0.171265 -1 2.66025 -1 6.14127H1C1 3.76482 2.93608 1.82874 5.31253 1.82874V-0.171265ZM-1 6.14127C-1 9.7556 0.896169 12.6556 3.06126 14.7891C5.22892 16.9251 7.75942 18.3887 9.2633 19.1528L10.1693 17.3698C8.75317 16.6502 6.42553 15.2963 4.46503 13.3645C2.50198 11.4301 1 9.01197 1 6.14127H-1ZM9.71631 19.2613H9.72998V17.2613H9.71631V19.2613ZM9.29346 19.161C9.46979 19.2466 9.71043 19.3288 10 19.3288V17.3288C10.0945 17.3288 10.1552 17.3562 10.1665 17.3616L9.29346 19.161ZM10 19.3288C10.2896 19.3288 10.5302 19.2466 10.7066 19.161L9.83347 17.3617C9.84481 17.3562 9.90551 17.3288 10 17.3288V19.3288ZM10.27 19.2613H10.2837V17.2613H10.27V19.2613ZM10.7367 19.1528C12.2406 18.3887 14.7711 16.9251 16.9387 14.7891C19.1038 12.6556 21 9.7556 21 6.14127H19C19 9.01197 17.498 11.4301 15.535 13.3645C13.5745 15.2963 11.2468 16.6502 9.83069 17.3698L10.7367 19.1528ZM21 6.14127C21 2.66041 18.17 -0.171265 14.6875 -0.171265V1.82874C17.0651 1.82874 19 3.76465 19 6.14127H21Z"
        fill="black"
        mask="url(#path-1-inside-1_2065_2481)"
      />
    </svg>
  );
};

const NotFoundPage = () => {
  return (
    <svg
      id="visual"
      viewBox="0 0 1200 540"
      width="1200"
      height="540"
      version="1.1"
    >
      <rect x="0" y="0" width="1200" height="540" fill="transparent"></rect>
      <g transform="translate(665.3170091807852 340.2879931882429)">
        <path
          d="M195.6 -392.3C211.2 -329.8 152.4 -191.9 118.6 -113.9C84.9 -36 76.2 -18 91.1 8.6C105.9 35.2 144.3 70.3 138.9 80.4C133.5 90.5 84.2 75.6 53.8 109.2C23.3 142.7 11.7 224.9 -22.8 264.4C-57.3 304 -114.7 300.9 -150 270.2C-185.4 239.4 -198.8 181 -183.6 131.3C-168.5 81.7 -124.7 40.8 -164.4 -22.9C-204.1 -86.7 -327.2 -173.3 -328.8 -199.5C-330.4 -225.6 -210.4 -191.2 -135.4 -219.3C-60.3 -247.5 -30.2 -338.3 29.9 -390.1C90 -441.9 180 -454.8 195.6 -392.3"
          fill="#151a3c"
        ></path>
      </g>
    </svg>
  );
};

const HeartRemove = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <path d="M19.5 10c-2.483 0-4.5 2.015-4.5 4.5s2.017 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.017-4.5-4.5-4.5zm2.5 5h-5v-1h5v1zm-6.527 4.593c-1.108 1.086-2.275 2.219-3.473 3.407-6.43-6.381-12-11.147-12-15.808 0-6.769 8.852-8.346 12-2.944 3.125-5.362 12-3.848 12 2.944 0 .746-.156 1.496-.423 2.253-1.116-.902-2.534-1.445-4.077-1.445-3.584 0-6.5 2.916-6.5 6.5 0 2.063.97 3.901 2.473 5.093z" />
    </svg>
  );
};

const SearchBar = () => {
  return (
    <svg
      clipRule="evenodd"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      viewBox="0 0 24 24"
    >
      <path
        d="m15.97 17.031c-1.479 1.238-3.384 1.985-5.461 1.985-4.697 0-8.509-3.812-8.509-8.508s3.812-8.508 8.509-8.508c4.695 0 8.508 3.812 8.508 8.508 0 2.078-.747 3.984-1.985 5.461l4.749 4.75c.146.146.219.338.219.531 0 .587-.537.75-.75.75-.192 0-.384-.073-.531-.22zm-5.461-13.53c-3.868 0-7.007 3.14-7.007 7.007s3.139 7.007 7.007 7.007c3.866 0 7.007-3.14 7.007-7.007s-3.141-7.007-7.007-7.007z"
        fillRule="nonzero"
        fill="#000"
      />
    </svg>
  );
};

const ArrowTop = () => {
  return (
    <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none">
      <path
        d="M17 15L12 10L7 15"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ArrowRight = () => {
  return (
    // <svg
    //   fill="#000000"
    //   height="17px"
    //   width="17px"
    //   version="1.1"
    //   id="Layer_1"
    //   viewBox="0 0 512.005 512.005"
    // >
    //   <g>
    //     <g>
    //       <path
    //         d="M388.418,240.923L153.751,6.256c-8.341-8.341-21.824-8.341-30.165,0s-8.341,21.824,0,30.165L343.17,256.005
    // 	L123.586,475.589c-8.341,8.341-8.341,21.824,0,30.165c4.16,4.16,9.621,6.251,15.083,6.251c5.461,0,10.923-2.091,15.083-6.251
    // 	l234.667-234.667C396.759,262.747,396.759,249.264,388.418,240.923z"
    //       />
    //     </g>
    //   </g>
    // </svg>

    <svg viewBox="0 0 24.00 24.00" fill="none">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M14.707 7.293a1 1 0 1 0-1.414 1.414L15.586 11H6a1 1 0 1 0 0 2h9.586l-2.293 2.293a1 1 0 0 0 1.414 1.414l4-4a1 1 0 0 0 0-1.414l-4-4Z"
          fill="#000000"
        ></path>
      </g>
    </svg>
  );
};

const ArrowLeft = () => {
  return (
    <svg
      fill="#000000"
      height="17px"
      width="17px"
      version="1.1"
      id="Layer_1"
      viewBox="0 0 512.006 512.006"
    >
      <g>
        <g>
          <path
            d="M388.419,475.59L168.834,256.005L388.418,36.421c8.341-8.341,8.341-21.824,0-30.165s-21.824-8.341-30.165,0
			L123.586,240.923c-8.341,8.341-8.341,21.824,0,30.165l234.667,234.667c4.16,4.16,9.621,6.251,15.083,6.251
			c5.461,0,10.923-2.091,15.083-6.251C396.76,497.414,396.76,483.931,388.419,475.59z"
          />
        </g>
      </g>
    </svg>
  );
};

const Quotes = () => {
  return (
    <svg xmlSpace="preserve" width={800} height={800} viewBox="0 0 1200 1200">
      <path d="M518.474 105.344C305.831 120.286.168 154.236 0 570.687v523.97h474.504v-560.61H316.946C306.965 384.354 430.23 345.701 564.274 316.03l-45.8-210.686zm635.724 0c-212.643 14.942-518.306 48.893-518.473 465.343v523.97h474.505v-560.61H952.672C942.689 384.354 1065.956 345.701 1200 316.03l-45.802-210.686z" />
    </svg>
  );
};

const Location = () => {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 1024 1024"
      className="icon"
      version="1.1"
    >
      <path
        d="M498.069 786.871s303.32-237.507 303.32-409.31-135.8-311.076-303.32-311.076-303.32 139.273-303.32 311.076 303.32 409.31 303.32 409.31z m0-682.312c146.614 0 265.466 121.438 265.466 271.239S498.834 741.519 498.834 741.519 232.603 525.598 232.603 375.798s118.852-271.239 265.466-271.239z m0 416.907c52.349 0 94.788-42.438 94.788-94.788v-37.915c0-52.349-42.438-94.788-94.788-94.788s-94.788 42.438-94.788 94.788v37.915c0 52.349 42.438 94.788 94.788 94.788z m-56.873-132.703c0-31.411 25.462-56.873 56.873-56.873s56.873 25.462 56.873 56.873v37.915c0 31.411-25.462 56.873-56.873 56.873s-56.873-25.462-56.873-56.873v-37.915z m246.448 417.066l-113.745 0.415v-0.415H232.663s-39.1 0-37.915-37.915c1.185-37.915 37.915-37.915 37.915-37.915h56.873s18.366-0.593 18.958-18.958c0.593-18.366-18.958-18.958-18.958-18.958h-56.873s-75.83-1.185-75.83 75.83 75.83 75.83 75.83 75.83h132.703v0.882h322.278s39.1 0 37.915 37.621c-1.185 37.621-37.915 37.621-37.915 37.621h-151.66s-18.958 0.298-18.958 18.664c0 18.364 18.958 18.958 18.958 18.958h151.66s75.83 1.175 75.83-75.242-75.83-76.418-75.83-76.418z"
        fill="#25EF25"
      />
    </svg>
  );
};

const LocationMap = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <path d="M11.239 7.237c-.004-.009-.288-.017-.24-.078l.137-.085c.013-.077.072-.162-.007-.304l.047-.125-.1.029s.141-.606.33-.332l-.08.093c.122.122.155.426.195.623.115.06.294.071.088.175.106-.018-.561.286-.648.161-.065-.076.288-.127.278-.157zm-.715-.159c-.077.078.003.128.082.094.114-.05.269-.048.284-.202l.073-.091-.101-.135c-.06-.012-.1.064-.137.095l-.066.017-.062.08.007.044-.08.098zm7 9.167l-.733-1.206-.724-1.186c-.73-1.194-1.388-2.276-1.961-3.296l-.07.067c-.376.156-.942-.509-1.339-.531.192.03.018-.49.018-.524-.153-.189-1.123.021-1.378.055-.479.063-.979.057-1.346.355-.258.21-.262.551-.524.716-.17.106-.356.072-.502.209-.258.245-.553.607-.697.929-.062.135.077.458.043.632-.336 1.063.085 2.538 1.375 2.701.312.039.638.209.955.114.252-.076.474-.248.745-.268.377-.025.22.529.737.379.251-.074.365.172.365.359-.084.391-.268.609.088.883.242.188.442.456.486.78.026.182.196.494-.015.602-.149.075-.259.507-.257.649.031.165.365.481.466.621.146.2.039.436.158.663.122.232.237.41.323.645.111.324.958-.007 1.156-.006.673.004 1.014-.944 1.487-1.235.267-.165.192-.616.51-.848.296-.215.608-.344.636-.741.021-.344-.259-1.062-.104-1.353l.102-.165zm-7.301-7.76c.041.172-.119.645-.154.795-.031.138.442.226.415.295.004-.008.642-.22.705-.275l.144-.323c.121-.081.248-.146.384-.196l.164-.285c.056-.021.71-.123.756-.101.165.075.469.389.583.531l.041.032c-.326-.67-.59-1.314-.796-1.942l-.083.036c-.222 0-.528.251-.663.405-.095.104-.669.337-.732.33.33.035.314.276.288.482-.068.476-1.096.035-1.052.216zm10.904 5.049c-.277 4.807-4.253 8.623-9.13 8.623-2.603 0-4.951-1.086-6.618-2.83-.198-.208-.346-.7-.02-.9l.331-.085c.259-.22-.242-1.111-.044-1.254.617-.441.324-.982-.055-1.429-.161-.19-1.043-1.1-1.143-.937.074-.249-.16-.85-.302-1.087-.239-.398-.553-.643-.679-1.081-.05-.174-.05-.704-.153-.826-.041-.05-.358-.185-.347-.257.305-1.82 1.147-3.458 2.364-4.751l.821-.33c.515-.773.545-.173 1.008-.375.154 0 .331-.634.496-.734.289-.185.068-.185.015-.27-.112-.184 2.411-1.103 2.453-.938.034.14-1.249.809-1.108.788-.326.043-.388.627-.328.625.163-.005 1.182-.774 1.657-.61.466.161 1.301-.37 1.627-.64l.04-.038c.029-.761.195-1.494.481-2.172l-.493-.026c-6.075 0-11 4.925-11 11s4.925 11 11 11c6.074 0 11-4.925 11-11 0-.764-.078-1.509-.227-2.229-.491.864-1.044 1.779-1.646 2.763zm1.873-9.1c0 2.45-1.951 5.373-4.5 9.566-2.549-4.193-4.5-7.116-4.5-9.566 0-2.449 2.139-4.434 4.5-4.434s4.5 1.985 4.5 4.434zm-2.75.066c0-.966-.784-1.75-1.75-1.75s-1.75.784-1.75 1.75.784 1.75 1.75 1.75 1.75-.784 1.75-1.75z" />
    </svg>
  );
};

const Cup = () => {
  return (
    <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none">
      <path
        d="M21.9999 8.16234L21.9999 8.23487C21.9999 9.09561 21.9999 9.52598 21.7927 9.8781C21.5855 10.2302 21.2093 10.4392 20.4569 10.8572L19.6636 11.298C20.2102 9.44984 20.3926 7.46414 20.4601 5.76597C20.4629 5.69316 20.4662 5.61945 20.4695 5.54497L20.4718 5.49279C21.1231 5.71896 21.4887 5.88758 21.7168 6.20408C22 6.59692 22 7.11873 21.9999 8.16234Z"
        fill="#1C274C"
      />
      <path
        d="M2 8.16234L2 8.23487C2.00003 9.09561 2.00004 9.52598 2.20723 9.8781C2.41442 10.2302 2.79063 10.4392 3.54305 10.8572L4.33681 11.2982C3.79007 9.45001 3.60767 7.46422 3.54025 5.76597C3.53736 5.69316 3.5341 5.61945 3.53081 5.54497L3.5285 5.49266C2.87701 5.7189 2.51126 5.88752 2.2831 6.20408C1.99996 6.59692 1.99997 7.11873 2 8.16234Z"
        fill="#1C274C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0002 2C13.7837 2 15.2531 2.15709 16.3771 2.34674C17.5159 2.53887 18.0852 2.63494 18.5609 3.22083C19.0367 3.80673 19.0115 4.43998 18.9612 5.70647C18.7886 10.0545 17.8503 15.4853 12.75 15.9657V19.5H14.1802C14.6569 19.5 15.0673 19.8365 15.1608 20.3039L15.35 21.25H18C18.4142 21.25 18.75 21.5858 18.75 22C18.75 22.4142 18.4142 22.75 18 22.75H6C5.58579 22.75 5.25 22.4142 5.25 22C5.25 21.5858 5.58579 21.25 6 21.25H8.65L8.83922 20.3039C8.93271 19.8365 9.34312 19.5 9.8198 19.5H11.25V15.9657C6.14996 15.4851 5.21169 10.0544 5.03907 5.70647C4.98879 4.43998 4.96365 3.80673 5.43937 3.22083C5.91508 2.63494 6.48445 2.53887 7.62318 2.34674C8.74724 2.15709 10.2166 2 12.0002 2ZM12.9524 6.19887L12.8541 6.02251C12.4741 5.34084 12.2841 5 12 5C11.7159 5 11.5259 5.34084 11.1459 6.02251L11.0476 6.19887C10.9397 6.39258 10.8857 6.48944 10.8015 6.55334C10.7173 6.61725 10.6125 6.64097 10.4028 6.68841L10.2119 6.73161C9.47396 6.89857 9.10501 6.98205 9.01723 7.26432C8.92945 7.54659 9.18097 7.84072 9.68403 8.42898L9.81418 8.58117C9.95713 8.74833 10.0286 8.83191 10.0608 8.93532C10.0929 9.03872 10.0821 9.15023 10.0605 9.37327L10.0408 9.57632C9.96476 10.3612 9.92674 10.7536 10.1565 10.9281C10.3864 11.1025 10.7318 10.9435 11.4227 10.6254L11.6014 10.5431C11.7978 10.4527 11.8959 10.4075 12 10.4075C12.1041 10.4075 12.2022 10.4527 12.3986 10.5431L12.5773 10.6254C13.2682 10.9435 13.6136 11.1025 13.8435 10.9281C14.0733 10.7536 14.0352 10.3612 13.9592 9.57632L13.9395 9.37327C13.9179 9.15023 13.9071 9.03872 13.9392 8.93532C13.9714 8.83191 14.0429 8.74833 14.1858 8.58117L14.316 8.42898C14.819 7.84072 15.0706 7.54659 14.9828 7.26432C14.895 6.98205 14.526 6.89857 13.7881 6.73161L13.5972 6.68841C13.3875 6.64097 13.2827 6.61725 13.1985 6.55334C13.1143 6.48944 13.0603 6.39258 12.9524 6.19887Z"
        fill="#1C274C"
      />
    </svg>
  );
};

const ContactFooter = () => {
  return (
    <svg width={3472} height={400} preserveAspectRatio="none">
      <g fill="none" mask='url("#a")'>
        <path fill='url("#b")' d="M0 0h3472v400H0z" />
        <use xlinkHref="#c" />
        <use xlinkHref="#c" x={720} />
        <use xlinkHref="#c" x={1440} />
        <use xlinkHref="#c" x={2160} />
        <use xlinkHref="#c" x={2880} />
      </g>
      <defs>
        <path id="h" d="M-1 0a1 1 0 1 0 2 0 1 1 0 1 0-2 0z" />
        <path id="e" d="M-3 0a3 3 0 1 0 6 0 3 3 0 1 0-6 0z" />
        <path id="g" d="M-5 0A5 5 0 1 0 5 0 5 5 0 1 0-5 0z" />
        <path id="f" d="m2-2-4 4z" />
        <path id="d" d="M6-6-6 6z" />
        <path id="i" d="m30-30-60 60z" />
        <linearGradient
          id="b"
          x1="22.12%"
          x2="77.88%"
          y1="-192%"
          y2="292%"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#0e2a47" />
          <stop offset={1} stopColor="#00459e" />
        </linearGradient>
        <mask id="a">
          <path fill="#fff" d="M0 0h3472v400H0z" />
        </mask>
      </defs>
      <symbol id="c">
        <use xlinkHref="#d" x={30} y={30} stroke="#1c538e" />
        <use xlinkHref="#e" x={30} y={90} stroke="#1c538e" />
        <use xlinkHref="#f" x={30} y={150} stroke="#1c538e" />
        <use xlinkHref="#g" x={30} y={210} stroke="#1c538e" />
        <use xlinkHref="#e" x={30} y={270} stroke="#1c538e" />
        <use xlinkHref="#g" x={30} y={330} stroke="#1c538e" />
        <use xlinkHref="#h" x={30} y={390} stroke="#1c538e" />
        <use xlinkHref="#g" x={90} y={30} stroke="#1c538e" />
        <use xlinkHref="#d" x={90} y={90} stroke="#1c538e" />
        <use xlinkHref="#g" x={90} y={150} stroke="#1c538e" />
        <use xlinkHref="#d" x={90} y={210} stroke="#1c538e" />
        <use xlinkHref="#h" x={90} y={270} stroke="#1c538e" />
        <use xlinkHref="#g" x={90} y={330} stroke="#1c538e" />
        <use xlinkHref="#d" x={90} y={390} stroke="#1c538e" />
        <use xlinkHref="#g" x={150} y={30} stroke="#1c538e" />
        <use xlinkHref="#f" x={150} y={90} stroke="#1c538e" />
        <use xlinkHref="#h" x={150} y={150} stroke="#1c538e" />
        <use xlinkHref="#h" x={150} y={210} stroke="#1c538e" />
        <use xlinkHref="#f" x={150} y={270} stroke="#1c538e" />
        <use xlinkHref="#f" x={150} y={330} stroke="#1c538e" />
        <use xlinkHref="#f" x={150} y={390} stroke="#1c538e" />
        <use xlinkHref="#d" x={210} y={30} stroke="#1c538e" />
        <use xlinkHref="#d" x={210} y={90} stroke="#1c538e" />
        <use xlinkHref="#d" x={210} y={150} stroke="#1c538e" />
        <use xlinkHref="#g" x={210} y={210} stroke="#1c538e" />
        <use xlinkHref="#g" x={210} y={270} stroke="#1c538e" />
        <use xlinkHref="#g" x={210} y={330} stroke="#1c538e" />
        <use xlinkHref="#g" x={210} y={390} stroke="#1c538e" />
        <use xlinkHref="#i" x={270} y={30} stroke="#1c538e" strokeWidth={3} />
        <use xlinkHref="#d" x={270} y={90} stroke="#1c538e" />
        <use xlinkHref="#h" x={270} y={150} stroke="#1c538e" />
        <use xlinkHref="#g" x={270} y={210} stroke="#1c538e" />
        <use xlinkHref="#e" x={270} y={270} stroke="#1c538e" />
        <use xlinkHref="#g" x={270} y={330} stroke="#1c538e" />
        <use xlinkHref="#d" x={270} y={390} stroke="#1c538e" />
        <use xlinkHref="#g" x={330} y={30} stroke="#1c538e" />
        <use xlinkHref="#d" x={330} y={90} stroke="#1c538e" />
        <use xlinkHref="#g" x={330} y={150} stroke="#1c538e" />
        <use xlinkHref="#h" x={330} y={210} stroke="#1c538e" />
        <use xlinkHref="#f" x={330} y={270} stroke="#1c538e" />
        <use xlinkHref="#g" x={330} y={330} stroke="#1c538e" />
        <use xlinkHref="#f" x={330} y={390} stroke="#1c538e" />
        <use xlinkHref="#g" x={390} y={30} stroke="#1c538e" />
        <use xlinkHref="#g" x={390} y={90} stroke="#1c538e" />
        <use xlinkHref="#g" x={390} y={150} stroke="#1c538e" />
        <use xlinkHref="#h" x={390} y={210} stroke="#1c538e" />
        <use xlinkHref="#f" x={390} y={270} stroke="#1c538e" />
        <use xlinkHref="#h" x={390} y={330} stroke="#1c538e" />
        <use xlinkHref="#d" x={390} y={390} stroke="#1c538e" />
        <use xlinkHref="#h" x={450} y={30} stroke="#1c538e" />
        <use xlinkHref="#d" x={450} y={90} stroke="#1c538e" />
        <use xlinkHref="#e" x={450} y={150} stroke="#1c538e" />
        <use xlinkHref="#g" x={450} y={210} stroke="#1c538e" />
        <use xlinkHref="#d" x={450} y={270} stroke="#1c538e" />
        <use xlinkHref="#d" x={450} y={330} stroke="#1c538e" />
        <use xlinkHref="#h" x={450} y={390} stroke="#1c538e" />
        <use xlinkHref="#g" x={510} y={30} stroke="#1c538e" />
        <use xlinkHref="#h" x={510} y={90} stroke="#1c538e" />
        <use xlinkHref="#g" x={510} y={150} stroke="#1c538e" />
        <use xlinkHref="#f" x={510} y={210} stroke="#1c538e" />
        <use xlinkHref="#d" x={510} y={270} stroke="#1c538e" />
        <use xlinkHref="#g" x={510} y={330} stroke="#1c538e" />
        <use xlinkHref="#f" x={510} y={390} stroke="#1c538e" />
        <use xlinkHref="#d" x={570} y={30} stroke="#1c538e" />
        <use xlinkHref="#g" x={570} y={90} stroke="#1c538e" />
        <use xlinkHref="#f" x={570} y={150} stroke="#1c538e" />
        <use xlinkHref="#g" x={570} y={210} stroke="#1c538e" />
        <use xlinkHref="#d" x={570} y={270} stroke="#1c538e" />
        <use xlinkHref="#f" x={570} y={330} stroke="#1c538e" />
        <use xlinkHref="#d" x={570} y={390} stroke="#1c538e" />
        <use xlinkHref="#f" x={630} y={30} stroke="#1c538e" />
        <use xlinkHref="#i" x={630} y={90} stroke="#1c538e" strokeWidth={3} />
        <use xlinkHref="#g" x={630} y={150} stroke="#1c538e" />
        <use xlinkHref="#i" x={630} y={210} stroke="#1c538e" strokeWidth={3} />
        <use xlinkHref="#g" x={630} y={270} stroke="#1c538e" />
        <use xlinkHref="#d" x={630} y={330} stroke="#1c538e" />
        <use xlinkHref="#e" x={630} y={390} stroke="#1c538e" />
        <use xlinkHref="#h" x={690} y={30} stroke="#1c538e" />
        <use xlinkHref="#g" x={690} y={90} stroke="#1c538e" />
        <use xlinkHref="#f" x={690} y={150} stroke="#1c538e" />
        <use xlinkHref="#g" x={690} y={210} stroke="#1c538e" />
        <use xlinkHref="#g" x={690} y={270} stroke="#1c538e" />
        <use xlinkHref="#e" x={690} y={330} stroke="#1c538e" />
        <use xlinkHref="#f" x={690} y={390} stroke="#1c538e" />
      </symbol>
    </svg>
  );
};

const ContactContent = () => {
  return (
    <svg
      version="1.1"
      width="3440"
      height="400"
      preserveAspectRatio="none"
      viewBox="0 0 3440 400"
    >
      <g mask='url("#SvgjsMask1017")' fill="none">
        <path
          d="M1403.64 472.91C1730.77 472.69 2049.78 328.47 2704.13 328.01 3358.48 327.55 3677.4 180.25 4004.62 180.01"
          stroke="rgba(51,121,194,0.58)"
          strokeWidth="2"
        ></path>
        <path
          d="M1120.38 424.77C1435.02 421.52 1724.44 83.28 2331.75 83.16 2939.05 83.04 3237.51 246.79 3543.11 247.16"
          stroke="rgba(51,121,194,0.58)"
          strokeWidth="2"
        ></path>
        <path
          d="M1600.33 439.63C1902.71 438.89 2195.88 235.34 2792.49 235.32 3389.1 235.3 3685.48 339.22 3984.65 339.32"
          stroke="rgba(51,121,194,0.58)"
          strokeWidth="2"
        ></path>
        <path
          d="M293.97 436.76C695.02 436.22 1087.63 213.61 1882.56 213.58 2677.49 213.55 3073.28 309.54 3471.15 309.58"
          stroke="rgba(51,121,194,0.58)"
          strokeWidth="2"
        ></path>
        <path
          d="M217.92 459.96C496.14 459.07 763.43 254.7 1311.69 254.6 1859.95 254.5 1858.58 304.6 2405.46 304.6 2952.34 304.6 3225.5 254.61 3499.23 254.6"
          stroke="rgba(51,121,194,0.58)"
          strokeWidth="2"
        ></path>
      </g>
      <defs>
        <mask id="SvgjsMask1017">
          <rect width="3440" height="400" fill="#ffffff"></rect>
        </mask>
      </defs>
    </svg>
  );
};

export const Filter = () => {
  return (
    <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none">
      <path
        d="M21 6H19M21 12H16M21 18H16M7 20V13.5612C7 13.3532 7 13.2492 6.97958 13.1497C6.96147 13.0615 6.93151 12.9761 6.89052 12.8958C6.84431 12.8054 6.77934 12.7242 6.64939 12.5617L3.35061 8.43826C3.22066 8.27583 3.15569 8.19461 3.10948 8.10417C3.06849 8.02393 3.03853 7.93852 3.02042 7.85026C3 7.75078 3 7.64677 3 7.43875V5.6C3 5.03995 3 4.75992 3.10899 4.54601C3.20487 4.35785 3.35785 4.20487 3.54601 4.10899C3.75992 4 4.03995 4 4.6 4H13.4C13.9601 4 14.2401 4 14.454 4.10899C14.6422 4.20487 14.7951 4.35785 14.891 4.54601C15 4.75992 15 5.03995 15 5.6V7.43875C15 7.64677 15 7.75078 14.9796 7.85026C14.9615 7.93852 14.9315 8.02393 14.8905 8.10417C14.8443 8.19461 14.7793 8.27583 14.6494 8.43826L11.3506 12.5617C11.2207 12.7242 11.1557 12.8054 11.1095 12.8958C11.0685 12.9761 11.0385 13.0615 11.0204 13.1497C11 13.2492 11 13.3532 11 13.5612V17L7 20Z"
        stroke="#000000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const OpenQuote = () => {
  return (
    <svg
      clipRule="evenodd"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      viewBox="0 0 24 24"
    >
      <path
        d="m21.301 4c.411 0 .699.313.699.663 0 .248-.145.515-.497.702-1.788.948-3.858 4.226-3.858 6.248 3.016-.092 4.326 2.582 4.326 4.258 0 2.007-1.738 4.129-4.308 4.129-3.24 0-4.83-2.547-4.83-5.307 0-5.98 6.834-10.693 8.468-10.693zm-10.833 0c.41 0 .699.313.699.663 0 .248-.145.515-.497.702-1.788.948-3.858 4.226-3.858 6.248 3.016-.092 4.326 2.582 4.326 4.258 0 2.007-1.739 4.129-4.308 4.129-3.241 0-4.83-2.547-4.83-5.307 0-5.98 6.833-10.693 8.468-10.693z"
        fillRule="nonzero"
        fill="#fff"
      />
    </svg>
  );
};

export const CloseQuote = () => {
  return (
    <svg
      clipRule="evenodd"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      viewBox="0 0 24 24"
    >
      <path
        d="m2.699 20c-.411 0-.699-.312-.699-.662 0-.249.145-.516.497-.703 1.788-.947 3.858-4.226 3.858-6.248-3.016.092-4.326-2.582-4.326-4.258 0-2.006 1.738-4.129 4.308-4.129 3.241 0 4.83 2.547 4.83 5.307 0 5.981-6.834 10.693-8.468 10.693zm10.833 0c-.41 0-.699-.312-.699-.662 0-.249.145-.516.497-.703 1.788-.947 3.858-4.226 3.858-6.248-3.015.092-4.326-2.582-4.326-4.258 0-2.006 1.739-4.129 4.308-4.129 3.241 0 4.83 2.547 4.83 5.307 0 5.981-6.833 10.693-8.468 10.693z"
        fillRule="nonzero"
        fill="#fff"
      />
    </svg>
  );
};

export const ScrollMouse = () => {
  return (
    <svg
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      imageRendering="optimizeQuality"
      fillRule="evenodd"
      clipRule="evenodd"
      viewBox="0 0 279 512.47"
    >
      <path
        fillRule="nonzero"
        d="M148.59 65.11c0 5.01-4.07 9.08-9.08 9.08s-9.08-4.07-9.08-9.08v-33.4l-9.48 9.93c-3.45 3.62-9.19 3.76-12.8.32-3.62-3.44-3.77-9.18-.33-12.8l24.71-25.88A9.05 9.05 0 0 1 139.51 0c2.8 0 5.31 1.27 6.98 3.28l24.69 25.88c3.44 3.62 3.29 9.36-.33 12.8-3.61 3.44-9.35 3.3-12.8-.32l-9.46-9.93v33.4zm112.25 212.22H18.16v112.16c0 28.84 11.78 55.06 30.76 74.02 19.01 19.02 45.22 30.81 74.06 30.81h33.04c28.81 0 55.02-11.8 74.02-30.81 19.02-18.96 30.8-45.18 30.8-74.02V277.33zM18.16 259.17h112.26v-32.01c-9.45-3.68-16.24-12.93-16.24-23.61V166.9c0-10.69 6.76-19.94 16.24-23.62v-41.11h-7.44c-28.83 0-55.05 11.79-74.05 30.77-18.98 19-30.77 45.23-30.77 74.05v52.18zm130.42 0h112.26v-52.18c0-28.82-11.79-55.05-30.77-74.05-19-18.98-45.22-30.77-74.05-30.77h-7.44v41.1c9.48 3.67 16.24 12.9 16.24 23.63v36.65c0 10.72-6.79 19.95-16.24 23.62v32zm7.44 253.3h-33.04c-33.79 0-64.53-13.84-86.82-36.11l-.07-.07C13.83 454 0 423.27 0 389.49v-182.5c0-33.81 13.84-64.55 36.11-86.83 22.32-22.31 53.06-36.15 86.87-36.15h33.04c33.81 0 64.55 13.84 86.83 36.11 22.31 22.32 36.15 53.06 36.15 86.87v182.5c0 33.8-13.85 64.55-36.14 86.85-22.25 22.29-53.01 36.13-86.84 36.13zm-25.59-213c0-5.01 4.07-9.08 9.08-9.08s9.08 4.07 9.08 9.08v33.39l9.46-9.92c3.45-3.62 9.19-3.77 12.8-.33 3.62 3.44 3.77 9.18.33 12.8l-24.69 25.88c-1.67 2-4.18 3.27-6.98 3.27-2.8 0-5.31-1.27-6.98-3.27l-24.71-25.88c-3.44-3.62-3.29-9.36.33-12.8 3.61-3.44 9.35-3.29 12.8.33l9.48 9.93v-33.4z"
      />
    </svg>
  );
};

export const SquarePattern = () => {
  return (
    <svg width="600" height="3000">
      <rect
        x="0"
        y="0"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="100" y1="0" x2="100" y2="200" stroke="#878686" />

      <rect
        x="200"
        y="0"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="200" y1="100" x2="400" y2="100" stroke="#878686" />

      <rect
        x="400"
        y="0"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="500" y1="0" x2="500" y2="200" stroke="#878686" />

      <rect
        x="0"
        y="200"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="0" y1="300" x2="200" y2="300" stroke="#878686" />

      <rect
        x="200"
        y="200"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="100" y1="200" x2="100" y2="400" stroke="#878686" />

      <rect
        x="400"
        y="200"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="400" y1="300" x2="600" y2="300" stroke="#878686" />

      <rect
        x="0"
        y="400"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="100" y1="400" x2="100" y2="600" stroke="#878686" />

      <rect
        x="200"
        y="400"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="200" y1="500" x2="400" y2="500" stroke="#878686" />

      <rect
        x="400"
        y="400"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="500" y1="400" x2="500" y2="600" stroke="#878686" />

      <rect
        x="0"
        y="600"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="0" y1="700" x2="200" y2="700" stroke="#878686" />

      <rect
        x="200"
        y="600"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="100" y1="600" x2="100" y2="800" stroke="#878686" />

      <rect
        x="400"
        y="600"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="400" y1="700" x2="600" y2="700" stroke="#878686" />

      <rect
        x="0"
        y="800"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="100" y1="800" x2="100" y2="1000" stroke="#878686" />

      <rect
        x="200"
        y="800"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="200" y1="900" x2="400" y2="900" stroke="#878686" />

      <rect
        x="400"
        y="800"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="500" y1="800" x2="500" y2="1000" stroke="#878686" />

      <rect
        x="0"
        y="1000"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="0" y1="1100" x2="200" y2="1100" stroke="#878686" />

      <rect
        x="200"
        y="1000"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="100" y1="1000" x2="100" y2="1200" stroke="#878686" />

      <rect
        x="400"
        y="1000"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="400" y1="1100" x2="600" y2="1100" stroke="#878686" />

      <rect
        x="0"
        y="1200"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="100" y1="1200" x2="100" y2="1400" stroke="#878686" />

      <rect
        x="200"
        y="1200"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="200" y1="1300" x2="400" y2="1300" stroke="#878686" />

      <rect
        x="400"
        y="1200"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="500" y1="1200" x2="500" y2="1400" stroke="#878686" />

      <rect
        x="0"
        y="1400"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="0" y1="1500" x2="200" y2="1500" stroke="#878686" />

      <rect
        x="200"
        y="1400"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="100" y1="1400" x2="100" y2="1600" stroke="#878686" />

      <rect
        x="400"
        y="1400"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="400" y1="1500" x2="600" y2="1500" stroke="#878686" />

      <rect
        x="0"
        y="1600"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="100" y1="1600" x2="100" y2="1800" stroke="#878686" />

      <rect
        x="200"
        y="1600"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="200" y1="1700" x2="400" y2="1700" stroke="#878686" />

      <rect
        x="400"
        y="1600"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="500" y1="1600" x2="500" y2="1800" stroke="#878686" />

      <rect
        x="0"
        y="1800"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="0" y1="1900" x2="200" y2="1900" stroke="#878686" />

      <rect
        x="200"
        y="1800"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="100" y1="1800" x2="100" y2="2000" stroke="#878686" />

      <rect
        x="400"
        y="1800"
        width="200"
        height="200"
        fill="transparent"
        stroke="#878686"
      />
      <line x1="400" y1="1900" x2="600" y2="1900" stroke="#878686" />
    </svg>
  );
};

export const TimeManagement = () => {
  return (
    <svg
      data-name="Layer 1"
      width="675.67004"
      height="631.94692"
      viewBox="0 0 675.67004 631.94692"
    >
      <path
        d="M886.75657,617.4844l30.31095,4.737a98.98541,98.98541,0,0,0,20.60431-42.93875c-22.16391,18.14266-55.86923,8.5016-82.74464,18.40656A59.5399,59.5399,0,0,0,819.307,635.03277L804.49369,650.9701A99.77016,99.77016,0,0,0,887.905,646.378a96.3717,96.3717,0,0,0,19.64-14.09929C896.93923,625.60042,886.75657,617.4844,886.75657,617.4844Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#f2f2f2"
      />
      <path
        d="M875.99631,569.00709l29.24218-9.2783a98.98538,98.98538,0,0,0-.70813-47.62114c-11.74636,26.12313-46.21379,32.5259-65.851,53.37718a59.53993,59.53993,0,0,0-15.227,49.31l-6.15081,20.871a99.77014,99.77014,0,0,0,72.60872-41.31,96.37253,96.37253,0,0,0,11.29063-21.37854C888.72981,571.73,875.99631,569.00709,875.99631,569.00709Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#f2f2f2"
      />
      <path
        d="M937.835,660.62474a1.18647,1.18647,0,0,1-1.19006,1.19H263.355a1.19,1.19,0,0,1,0-2.38h673.29A1.18651,1.18651,0,0,1,937.835,660.62474Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#ccc"
      />
      <circle cx="278.99773" cy="260.8659" r="215" fill="#e6e6e6" />
      <path
        d="M726.16271,394.89244a184.74377,184.74377,0,0,1-74.67,148.51c-1.55,1.16-3.13,2.29-4.72,3.39a185.03127,185.03127,0,0,1-211.22,0c-1.59-1.1-3.17-2.23-4.72-3.39a185.01966,185.01966,0,0,1,0-297.02c1.55-1.16,3.13-2.29,4.72-3.39a185.0315,185.0315,0,0,1,211.22,0c1.59,1.1,3.17,2.23,4.72,3.39A184.74369,184.74369,0,0,1,726.16271,394.89244Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#fff"
      />
      <circle cx="278.99773" cy="260.8659" r="169" fill="#5987a4" />
      <path
        d="M541.60362,226.36486c-2.562,0-5.10815.067-7.64221.1798a168.99467,168.99467,0,0,1-7.15649,337.168c4.87781.42328,9.81116.65223,14.7987.65223a169,169,0,0,0,0-338Z"
        transform="translate(-262.16498 -134.02654)"
        opacity="0.2"
      />
      <path
        d="M541.66271,213.89244a5.50968,5.50968,0,0,0-5.5,5.5v24a5.5,5.5,0,0,0,11,0v-24A5.50968,5.50968,0,0,0,541.66271,213.89244Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#fff"
      />
      <path
        d="M651.49272,246.38243c-1.55-1.16-3.13-2.29-4.72-3.39a5.49662,5.49662,0,0,0-4.9,2.39l-13.51,19.83a5.49872,5.49872,0,0,0,9.09,6.19l13.51-19.83A5.4644,5.4644,0,0,0,651.49272,246.38243Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#fff"
      />
      <path
        d="M712.87273,336.80242a5.4929,5.4929,0,0,0-7.16-3.02l-22.24,9.03a5.49945,5.49945,0,0,0,4.14,10.19l22.24-9.03A5.51241,5.51241,0,0,0,712.87273,336.80242Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#fff"
      />
      <path
        d="M453.96269,265.21245l-13.51-19.83a5.49661,5.49661,0,0,0-4.9-2.39c-1.59,1.1-3.17,2.23-4.72,3.39a5.46442,5.46442,0,0,0,.53,5.19l13.51,19.83a5.49872,5.49872,0,0,0,9.09-6.19Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#fff"
      />
      <path
        d="M398.85271,342.81243l-22.24-9.03a5.49942,5.49942,0,0,0-4.14,10.18994l22.24,9.03a5.49945,5.49945,0,0,0,4.14-10.19Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#fff"
      />
      <path
        d="M541.66271,540.89244a5.50968,5.50968,0,0,0-5.5,5.5v24a5.5,5.5,0,0,0,11,0v-24A5.50968,5.50968,0,0,0,541.66271,540.89244Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#fff"
      />
      <path
        d="M650.96269,538.21245l-13.51-19.83a5.49872,5.49872,0,1,0-9.09,6.19l13.51,19.83a5.49657,5.49657,0,0,0,4.9,2.39c1.59-1.1,3.17-2.23,4.72-3.39A5.46436,5.46436,0,0,0,650.96269,538.21245Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#fff"
      />
      <path
        d="M709.85271,445.81243l-22.24-9.03a5.49942,5.49942,0,0,0-4.14,10.18994l22.24,9.03a5.49945,5.49945,0,0,0,4.14-10.19Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#fff"
      />
      <path
        d="M452.51268,516.93242a5.5,5.5,0,0,0-7.63995,1.45l-13.51,19.83a5.46439,5.46439,0,0,0-.53,5.19c1.55,1.16,3.13,2.29,4.72,3.39a5.49656,5.49656,0,0,0,4.9-2.39l13.51-19.83A5.49838,5.49838,0,0,0,452.51268,516.93242Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#fff"
      />
      <path
        d="M401.87273,439.80242a5.4929,5.4929,0,0,0-7.16-3.02l-22.24,9.03a5.49945,5.49945,0,0,0,4.14,10.19l22.24-9.03A5.51241,5.51241,0,0,0,401.87273,439.80242Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#fff"
      />
      <path
        d="M548.79894,392.16338a11.5131,11.5131,0,0,1-9.40873,13.26558l-97.59815,16.60128a11.5,11.5,0,0,1-3.85686-22.67432l97.59815-16.60127A11.5131,11.5131,0,0,1,548.79894,392.16338Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#3f3d56"
      />
      <path
        d="M651.51837,500.29429a7.5082,7.5082,0,0,1-10.60652.04177l-105.063-104.23895a7.5,7.5,0,0,1,10.56475-10.64828l105.063,104.23895A7.50819,7.50819,0,0,1,651.51837,500.29429Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#3f3d56"
      />
      <circle cx="278.99773" cy="260.8659" r="13" fill="#ccc" />
      <path
        d="M451.61885,169.47127c-19.95483,31.3725-50.40146,52.19272-87.94977,65.87042a7.05892,7.05892,0,0,1-9.88158-1.41838l0,0c-20.3959-27.23248-15.79051-66.15312,11.1278-86.96189a62.06846,62.06846,0,0,1,87.55785,11.87509l.56413.75322A7.05892,7.05892,0,0,1,451.61885,169.47127Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#e6e6e6"
      />
      <path
        d="M629.85228,158.83648a62.06846,62.06846,0,0,1,87.55785-11.87509c26.91832,20.80877,31.52371,59.72941,11.1278,86.96189l0,0a7.05889,7.05889,0,0,1-9.88155,1.41838c-34.8573-13.34536-63.4422-36.43945-87.94983-65.87042a7.059,7.059,0,0,1-1.41838-9.88157Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#e6e6e6"
      />
      <path
        d="M621.10592,581.16067a5.50968,5.50968,0,0,0-2.11376,7.48546l31.74188,56.7226a5.5,5.5,0,0,0,9.59921-5.3717l-31.74188-56.7226A5.50968,5.50968,0,0,0,621.10592,581.16067Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#e6e6e6"
      />
      <path
        d="M453.734,583.27443,421.99216,639.997a5.5,5.5,0,0,0,9.59921,5.3717l31.74188-56.7226a5.5,5.5,0,1,0-9.59921-5.3717Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#e6e6e6"
      />
      <circle cx="394.99773" cy="508.8659" r="17" fill="#e6e6e6" />
      <circle cx="406.99773" cy="73.8659" r="17" fill="#e6e6e6" />
      <circle cx="277.99773" cy="33.8659" r="17" fill="#e6e6e6" />
      <circle cx="154.99773" cy="71.8659" r="17" fill="#e6e6e6" />
      <circle cx="165.99773" cy="508.8659" r="17" fill="#e6e6e6" />
      <path
        d="M643.82785,490.73326a8.51615,8.51615,0,0,0,12.95041,1.67682l26.67551,14.29343-1.43061-15.66135L656.911,479.86993a8.56232,8.56232,0,0,0-13.08312,10.86333Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#ffb7b7"
      />
      <path
        d="M663.26422,496.199l10.45348-14.42967,50.35989,23.80654,62.667-11.75832a21.47122,21.47122,0,0,1,25.43021,21.06258h0a21.49411,21.49411,0,0,1-21.43119,21.51043l-71.81625.13324Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#3f3d56"
      />
      <polygon
        points="384.999 611.399 374.422 606.341 388.951 562.133 404.56 569.599 384.999 611.399"
        fill="#ffb7b7"
      />
      <path
        d="M718.07,738.29872c-.7691.48175-1.5382.95554-2.31507,1.42951-1.546.94777-3.10749,1.88-4.669,2.79663-.78465.45843-1.57707.91685-2.36172,1.3675v.02314l-.04661.00777-.01551.00778-1.19641.29531-1.71686-4.537-.79243-2.08974-1.1187-2.95994-2.051-5.41478-10.79851-28.51121,16.78822-4.1408.62926,2.5715h.00778l.31072,1.274,5.86543,23.788,1.19637,4.86323.03883.14756.72249,2.9055.62153,2.51706.69139,2.81238Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#ffb7b7"
      />
      <path
        d="M818.21837,638.17372c-1.06431,1.70913-2.152,3.41049-3.24732,5.09629q-3.05317,4.70782-6.26938,9.27587c0,.00777-.00777.00777-.01555.01555a21.93387,21.93387,0,0,1-4.11742,3.0065c-.06216.04661-.13205.07767-.19422.1165a15.17964,15.17964,0,0,1-3.46487,1.39063c-.435.10873-.87787.2175-1.31292.32628-1.56925.37288-3.123.69142-4.669.97109-2.75012.48943-5.46917.839-8.17268,1.05653-.21754.02333-.435.03884-.65259.05439-11.117.81571-21.93889-.49721-33.23461-2.64912-5.578-1.05658-11.27244-2.32289-17.16893-3.6358-1.92663-.43505-3.861-.86232-5.81877-1.28959-.14761-.03106-.303-.06994-.45838-.101-2.79673-.61371-5.64006-1.2197-8.55334-1.81791-3.66686-.75354-7.45023-1.4838-11.38121-2.17523l.27967,5.53911a41.68909,41.68909,0,0,0,2.62583,12.4533c1.67807,4.90985,3.0065,8.79421.202,16.88144l-1.35176,3.91543a13.37221,13.37221,0,0,1-1.37508,11.83181l-.27188.41172,11.27243,28.519.73027,1.849h-5.77221l-7.10059.00778H696.69209l-17.36314-34.835-.83126-1.66252v-.08544l1.79457-66.94316c.02333-.59043.06994-1.18864.14761-1.77907a20.35271,20.35271,0,0,1,7.74545-13.704,19.60027,19.60027,0,0,1,14.59743-3.99314l5.9431.7691,12.14253,1.5693,8.55334,1.11092.17094.02328,25.22505,3.26288,1.81013-7.3803.33405-.12428,10.61989-3.89214,36.73054-13.46323.09322-.03105,2.41607-.88565.28744.46611c.08549.13987.17093.27971.2486.41954a71.99912,71.99912,0,0,1,5.80327,13.471,211.47728,211.47728,0,0,1,6.09844,23.28292q.10489.51275.18644.93226l.02333.08544c.02328.13206.03883.2175.04661.24083C820.36255,629.60479,819.77212,633.9087,818.21837,638.17372Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#2f2e41"
      />
      <path
        d="M819.76865,613.50321c-.11655-.49721-.26415-1.00215-.41949-1.49159a106.28979,106.28979,0,0,0-4.30386-10.89178c-1.83341-4.03975-4.032-8.36694-6.65-13.05146q-1.89946-3.40275-4.08637-7.0773-1.09539-1.84121-2.27623-3.75231a1.972,1.972,0,0,0-.101-.17089l-.22527-.37289-36.34216,4.86324-13.53311,1.81013-.80794,6.74325-.19421,1.6703c-.00778,0-.00778,0,0,.00777l-.54383,4.55247v.00778l-.72248,6.013-.06216-.00778-20.08216-2.60251-20.69591-2.68022-11.11706-1.43719a19.58836,19.58836,0,0,0-14.59743,3.99314,20.3629,20.3629,0,0,0-7.7454,13.704c-.06994.54382-.11655,1.10315-.13988,1.65475l-10.48779,24.85216a160.34347,160.34347,0,0,0-11.8551,46.64346l-7.69106,24.58806,1.09537.101,16.29879,1.51492,4.30386.404,9.47786-13.83611c1.07987-1.57707,2.10534-3.20071,3.06088-4.86323a73.86106,73.86106,0,0,0,4.18736-8.42133l20.5017-48.78763q2.37727.408,4.70785.77687,10.77918,1.748,20.69591,2.85112c21.49607,2.40055,40.11,2.587,56.68069.55159q6.98021-.85065,13.49429-2.2374,2.38894-.50113,4.71562-1.07986c.36511-.08545.72249-.17089,1.07987-.26416a19.82527,19.82527,0,0,0,13.86717-12.95824A20.22821,20.22821,0,0,0,819.76865,613.50321Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#2f2e41"
      />
      <path
        d="M650.54238,738.20692l-11.44332-5.48473-1.79458-.86231-2.86666,7.03847-20.01227,4.4049a4.74845,4.74845,0,0,0-.77687,9.035l19.55389,7.97851,6.20721-5.58572-1.52269,7.49684,7.36474,3.0065,8.07168-25.69121Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#2f2e41"
      />
      <polygon
        points="458.703 593.34 459.434 595.189 458.703 595.189 458.703 593.34"
        fill="#2f2e41"
      />
      <path
        d="M716.883,729.6106,704.89244,733.765l-1.88192.65,2.91542,7.01841-11.12085,17.21106a4.74844,4.74844,0,0,0,5.80521,6.9667l19.50836-8.08917.48047-8.3366,4.193,6.39847,7.34864-3.04564-12.34131-23.93495Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#2f2e41"
      />
      <path
        d="M816.77843,624.75865a4.40445,4.40445,0,0,1-2.043-.50683l-63.27441-33.0625-.731-2.99317-1.37793-9.47168.019-.08886,6.01758-27.74317c-.11035-.23828-.34082-.6289-.60107-1.07031-2.68653-4.55176-10.86231-18.40527,4.74121-37.48047l27.3955-31.93945,23.5127-1.01172.26758.33789A61.242,61.242,0,0,1,821.11485,536.617l-2.44824,44.2168,2.626,8.92969a24.6393,24.6393,0,0,1-.72168,15.94433l.602,14.459a4.41745,4.41745,0,0,1-4.39453,4.59179Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#3f3d56"
      />
      <path
        d="M761.89233,661.22445a8.5162,8.5162,0,0,0,2.12627-12.88426L779.23125,622.178l-15.70163.885-12.039,24.70838a8.56232,8.56232,0,0,0,10.40167,13.45308Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#ffb7b7"
      />
      <path
        d="M768.03088,641.99l-14.05733-10.94906,25.54384-49.50134L769.946,518.50143a21.47121,21.47121,0,0,1,21.9344-24.68218h0a21.49411,21.49411,0,0,1,20.752,22.16643l-2.36488,71.77743Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#3f3d56"
      />
      <path
        id="f4e08e8b-ef08-4d70-8ad3-b81af8a71ff9-84"
        data-name="a1ca5f83-7fa1-45b1-9d3b-bf096f25c0e5"
        d="M771.84232,467.13077V443.864a31.177,31.177,0,1,1,62.35408-.04005v.04005c5.49493,11.45055,2.05727,16.8945,0,23.2668a4.19307,4.19307,0,0,1-4.18608,4.18608H776.03048A4.1931,4.1931,0,0,1,771.84232,467.13077Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#2f2e41"
      />
      <circle cx="530.63215" cy="312.44125" r="23.33714" fill="#ffb7b7" />
      <path
        d="M817.22046,452.58578c-.21152-.03343-.423-.078-.63455-.11143-3.64026-.64562-7.28046-1.2801-10.90958-1.937l-.334-8.2266-4.39718,7.3694c-10.03015,3.32853-19.41462,1.44724-28.24248-2.70506a79.73731,79.73731,0,0,1-8.46054-4.66434,30.92749,30.92749,0,0,1,15.19553-21.886c.334-.18929.65677-.35617.99079-.52331a.0109.0109,0,0,0,.01107-.01115c.56776-.26716,1.14666-.52318,1.72556-.75691a25.70666,25.70666,0,0,1,26.98453,5.23209C816.27418,431.16737,819.48027,442.39976,817.22046,452.58578Z"
        transform="translate(-262.16498 -134.02654)"
        fill="#2f2e41"
      />
    </svg>
  );
};

export const MissionIlustration = () => {
  return (
    <svg
      data-name="Layer 1"
      width="650.11366"
      height="477.61186"
      viewBox="0 0 650.11366 477.61186"
    >
      <path
        d="M447.62579,563.92822c-95.21778,0-172.68262-77.46484-172.68262-172.68262S352.408,218.563,447.62579,218.563a173.06169,173.06169,0,0,1,141.16113,73.19336l-1.63379,1.15429A171.05768,171.05768,0,0,0,447.62579,220.563c-94.11426,0-170.68262,76.56836-170.68262,170.68261s76.56836,170.68262,170.68262,170.68262a169.5876,169.5876,0,0,0,135.49609-66.87207l1.58594,1.2168A171.569,171.569,0,0,1,447.62579,563.92822Z"
        transform="translate(-274.94317 -211.19407)"
        fill="#e6e6e6"
      />
      <path
        d="M519.01551,362.328a9.572,9.572,0,1,1,9.572-9.572A9.572,9.572,0,0,1,519.01551,362.328Z"
        transform="translate(-274.94317 -211.19407)"
        fill="#e6e6e6"
      />
      <path
        d="M522.35382,354.759l-2.003-2.003,2.003-2.003a.94424.94424,0,1,0-1.33535-1.33535l-2.003,2.003-2.003-2.003a.94422.94422,0,0,0-1.33533,1.33533l2.003,2.003-2.003,2.003a.94424.94424,0,0,0,1.33535,1.33535l2.003-2.003,2.003,2.003a.94422.94422,0,1,0,1.33533-1.33533Z"
        transform="translate(-274.94317 -211.19407)"
        fill="#fff"
      />
      <circle cx="196.46801" cy="19.04874" r="19.04875" fill="#e6e6e6" />
      <path
        d="M468.81254,240.1568a2.1183,2.1183,0,0,1-1.695-.84774l-5.19679-6.92916a2.11886,2.11886,0,1,1,3.39026-2.54253l3.39992,4.53288,8.73224-13.0982a2.119,2.119,0,0,1,3.52615,2.35077l-10.39358,15.59036a2.11978,2.11978,0,0,1-1.70427.94293Z"
        transform="translate(-274.94317 -211.19407)"
        fill="#fff"
      />
      <rect
        x="168.91529"
        y="53.41449"
        width="55.94642"
        height="11.96348"
        rx="5.06951"
        fill="#e6e6e6"
      />
      <rect
        x="140.50202"
        y="77.34146"
        width="112.77296"
        height="11.96348"
        rx="5.06951"
        fill="#e6e6e6"
      />
      <rect
        x="140.50202"
        y="101.26843"
        width="112.77296"
        height="11.96348"
        rx="5.06951"
        fill="#e6e6e6"
      />
      <path
        d="M460.72206,567.57545a9.572,9.572,0,1,1,9.572-9.572A9.572,9.572,0,0,1,460.72206,567.57545Z"
        transform="translate(-274.94317 -211.19407)"
        fill="#e6e6e6"
      />
      <path
        d="M464.06037,560.00643l-2.003-2.003,2.003-2.003a.94423.94423,0,0,0-1.33534-1.33535l-2.003,2.003-2.003-2.003a.94422.94422,0,0,0-1.33533,1.33533l2.003,2.003-2.003,2.003a.94423.94423,0,1,0,1.33534,1.33535l2.003-2.003,2.003,2.003a.94422.94422,0,1,0,1.33533-1.33533Z"
        transform="translate(-274.94317 -211.19407)"
        fill="#fff"
      />
      <circle cx="138.17456" cy="224.29618" r="19.04875" fill="#e6e6e6" />
      <path
        d="M410.51908,445.40424a2.11829,2.11829,0,0,1-1.69495-.84774l-5.19679-6.92916a2.11886,2.11886,0,1,1,3.39026-2.54253l3.39991,4.53288,8.73225-13.0982a2.119,2.119,0,1,1,3.52615,2.35077l-10.39358,15.59037a2.11981,2.11981,0,0,1-1.70427.94292Z"
        transform="translate(-274.94317 -211.19407)"
        fill="#fff"
      />
      <rect
        x="110.62184"
        y="258.66194"
        width="55.94642"
        height="11.96348"
        rx="5.06951"
        fill="#e6e6e6"
      />
      <rect
        x="82.20857"
        y="282.5889"
        width="112.77296"
        height="11.96348"
        rx="5.06951"
        fill="#e6e6e6"
      />
      <rect
        x="82.20857"
        y="306.51587"
        width="112.77296"
        height="11.96348"
        rx="5.06951"
        fill="#e6e6e6"
      />
      <path
        d="M658.73263,526.73553a13.21806,13.21806,0,1,1,13.21806-13.21806A13.21807,13.21807,0,0,1,658.73263,526.73553Z"
        transform="translate(-274.94317 -211.19407)"
        fill="#e6e6e6"
      />
      <path
        d="M663.34251,516.28344l-2.76592-2.76592,2.766-2.76595a1.3039,1.3039,0,0,0-1.844-1.844l-2.766,2.766-2.766-2.766a1.30388,1.30388,0,0,0-1.844,1.844l2.76595,2.76595-2.76595,2.766a1.3039,1.3039,0,0,0,1.844,1.844l2.76595-2.76595,2.76592,2.76592a1.30388,1.30388,0,0,0,1.844-1.844Z"
        transform="translate(-274.94317 -211.19407)"
        fill="#fff"
      />
      <circle cx="326.19937" cy="133.14441" r="26.3045" fill="#6c63ff" />
      <path
        d="M597.55406,358.02875a2.92518,2.92518,0,0,1-2.34058-1.17064l-7.17627-9.56852a2.92595,2.92595,0,1,1,4.68163-3.511l4.695,6.25947,12.0584-18.08737a2.92607,2.92607,0,1,1,4.86927,3.24619l-14.35254,21.52881a2.92726,2.92726,0,0,1-2.35343,1.30209C597.60835,358.02828,597.5812,358.02875,597.55406,358.02875Z"
        transform="translate(-274.94317 -211.19407)"
        fill="#fff"
      />
      <rect
        x="288.15169"
        y="180.60024"
        width="77.25667"
        height="16.52043"
        rx="5.06951"
        fill="#3f3d56"
      />
      <rect
        x="248.91568"
        y="213.64109"
        width="155.7287"
        height="16.52043"
        rx="5.06951"
        fill="#3f3d56"
      />
      <rect
        x="248.91568"
        y="246.68195"
        width="155.7287"
        height="16.52043"
        rx="5.06951"
        fill="#3f3d56"
      />
      <polygon
        points="450.676 463.637 437.92 463.636 431.851 414.433 450.679 414.434 450.676 463.637"
        fill="#ffb6b6"
      />
      <path
        d="M725.27906,670.66458l-13.62-5.54-.39-.16-7.52,5.7a16.01266,16.01266,0,0,0-16.01,16.01v.52h41.13v-16.53Z"
        transform="translate(-274.94317 -211.19407)"
        fill="#2f2e41"
      />
      <polygon
        points="558.496 452.952 546.314 456.737 525.916 411.551 543.896 405.965 558.496 452.952"
        fill="#ffb6b6"
      />
      <path
        d="M831.87728,660.26845l-14.6505-1.24835-.41994-.03708-5.48956,7.67493A16.01269,16.01269,0,0,0,800.77987,686.698l.15431.49654,39.277-12.20625L835.30557,659.203Z"
        transform="translate(-274.94317 -211.19407)"
        fill="#2f2e41"
      />
      <path
        d="M782.39948,422.78008l5.18807,14.75553v7.97628l-.723,8.77129,8.0301,29.25347,6.29922,64.50845,31.70078,95.49155-24.30708,7L746.52778,494.513,726.92613,652.3261l-22.22866-.593s-3.80284-9.19644-2.80284-14.19644,1,1,1-5-4.3351-3.3937-1.16755-8.19685,2.77323-9.00788,2.97039-11.90551-1.80284-119.89764-1.80284-123.89764-.69291-3.12391-.34645-7.062,4.74142-2.31915,3.54394-9.1286-1.59181-5.6191-1.39465-10.71427,2.95307-34.97005,2.95307-34.97005Z"
        transform="translate(-274.94317 -211.19407)"
        fill="#2f2e41"
      />
      <path
        d="M699.20556,427.58018l44.56215-42.97482,12.35119-34.972-18.21837-7.922c-9.35775,8.964-19.47307,36.88414-19.47307,36.88414l-30.66508,39.013c-.239.08184-.47728.16874-.71265.27268a8.77545,8.77545,0,1,0,12.15583,9.699Z"
        transform="translate(-274.94317 -211.19407)"
        fill="#ffb8b8"
      />
      <path
        d="M732.77418,345.61609l23.10872,7.33623.08711-.0145c8.601-1.44076,15.73808-15.48842,20.21041-27.01921a16.09129,16.09129,0,0,0-8.193-20.38362h0a16.12676,16.12676,0,0,0-16.89018,2.131l-11.86648,9.6963Z"
        transform="translate(-274.94317 -211.19407)"
        fill="#6c63ff"
      />
      <path
        d="M786.32548,441.73565l.135-.17939c7.21-9.56235-2.6512-33.24234-4.142-36.67665l6.70395-1.98581-1.1685-12.76444-.56282-5.69175,5.21244-4.95.01755-.12634,3.58474-25.511,4.69041-16.88452a37.32239,37.32239,0,0,0-9.65629-36.43113l-9.58845-9.51991L770.064,273.03391l-19.26055-.49726-6.92606,12.30362a28.08226,28.08226,0,0,0-22.46071,28.10125l.65206,32.7546-6.911,40.58295-.19388,7.37174-6.78319,7.158,1.25407,7.2366-5.074,2.02112-2.48292,10.28305c-.94826,1.18639-7.20952,9.10084-7.26648,11.30721-.00855.33125.22768.65774.74323,1.02651,4.05284,2.89967,26.70525,9.1828,36.90026,5.40544,10.85957-4.02024,53.4206,3.53019,53.84939,3.607Z"
        transform="translate(-274.94317 -211.19407)"
        fill="#6c63ff"
      />
      <path
        d="M739.11062,337.90144l-9.83856-19.61512c-14.28065.97549-42.62387,17.48727-42.62387,17.48727l-53.62638,11.36993a9.68825,9.68825,0,1,0,2.64134,16.55568l68.216-4.88972Z"
        transform="translate(-274.94317 -211.19407)"
        fill="#ffb8b8"
      />
      <path
        d="M735.14245,341.12219l25.695-19.09515,4.52613-16.31071a17.81557,17.81557,0,0,0-5.35827-18.02553h0a17.77346,17.77346,0,0,0-24.25389.78253c-9.66945,9.65146-20.698,23.11613-18.329,32.45288l.024.09464Z"
        transform="translate(-274.94317 -211.19407)"
        fill="#6c63ff"
      />
      <circle cx="486.12469" cy="34.03549" r="22.84874" fill="#ffb8b8" />
      <path
        d="M776.10436,269.12528c-3.82175-1.79511-8.28547-.70422-12.50455-.53819s-9.331-1.4245-10.22623-5.55085c-.66191-3.05105,1.32763-6.39514.074-9.25439-1.36715-3.11808-5.47069-3.56184-8.76148-4.43489a20.197,20.197,0,0,1-14.58438-18.90622c-.22863,1.70365,2.68647,2.26321,3.644.83567s.298-3.4034-.75775-4.75988-2.48076-2.43979-3.27694-3.9632-.64134-3.78587.91341-4.519a12.69623,12.69623,0,0,0,8.0415,6.61488c-.70719-2.1482.29272-4.56332,1.90215-6.15223a18.41178,18.41178,0,0,1,5.81093-3.422c5.26689-2.28313,11.4166-4.55509,16.517-1.92089a9.87675,9.87675,0,0,1,5.10582,6.91138c9.43478.79777,19.12284,11.01793,18.58581,20.47114-.57813,10.17663-1,11-9.4716,28.125"
        transform="translate(-274.94317 -211.19407)"
        fill="#2f2e41"
      />
      <path
        d="M890.563,687.78085H857.37645l-.14258-.25879c-.42432-.76953-.834-1.585-1.2168-2.42285-3.41845-7.31836-4.86328-15.68848-6.13818-23.07325l-.96-5.5664a3.43688,3.43688,0,0,1,5.41016-3.36231q7.56517,5.50488,15.13623,10.999c1.91113,1.39062,4.09375,3,6.18408,4.73925.20166-.97949.4126-1.96191.62353-2.93066a3.43916,3.43916,0,0,1,6.28077-1.08594l3.88281,6.23828c2.832,4.55567,5.33154,9.04493,4.82226,13.88672a.756.756,0,0,1-.01318.17578,10.94679,10.94679,0,0,1-.56348,2.33106Z"
        transform="translate(-274.94317 -211.19407)"
        fill="#f0f0f0"
      />
      <path
        d="M923.87237,688.49862l-315.3575.30731a1.19069,1.19069,0,0,1,0-2.38135l315.3575-.30731a1.19069,1.19069,0,0,1,0,2.38135Z"
        transform="translate(-274.94317 -211.19407)"
        fill="#cacaca"
      />
    </svg>
  );
};

export const ResultIlustration = () => {
  return (
    <svg
      data-name="Layer 1"
      width="786.97931"
      height="590.64559"
      viewBox="0 0 786.97931 590.64559"
    >
      <path
        id="e7a552b9-89f6-403f-a662-c184ed590622-792"
        data-name="Path 133"
        d="M946.77819,690.38938a189.65366,189.65366,0,0,1-8.86044,52.42624c-.11974.39391-.25264.78189-.38195,1.1758H904.47317c.03472-.3532.07064-.74718.10539-1.1758,2.20433-25.34327-10.38947-177.75122-25.58631-204.129C880.32367,540.82632,949.34172,609.86231,946.77819,690.38938Z"
        transform="translate(-206.17014 -154.54318)"
        fill="#f0f0f0"
      />
      <path
        id="b08f6207-3c71-42fa-8723-265175c281aa-793"
        data-name="Path 134"
        d="M944.2972,742.81562c-.27657.39391-.564.78788-.85852,1.1758H918.63424c.188-.3353.40589-.7292.65853-1.1758,4.09735-7.39491,16.22537-29.5053,27.48293-52.42624,12.09331-24.632,23.19759-50.198,22.26244-59.45114C969.328,633.024,977.69983,696.64437,944.2972,742.81562Z"
        transform="translate(-206.17014 -154.54318)"
        fill="#f0f0f0"
      />
      <path
        d="M830.34191,635.03175H206.17014V154.54318H830.34191Z"
        transform="translate(-206.17014 -154.54318)"
        fill="#fff"
      />
      <path
        d="M830.34191,635.03175H206.17014V154.54318H830.34191Zm-614.94969-9.22207H821.11983V163.76526H215.39222Z"
        transform="translate(-206.17014 -154.54318)"
        fill="#e5e5e5"
      />
      <path
        d="M369.52542,516.73978H322.26811a4.83226,4.83226,0,0,1-4.82688-4.82649V446.76885a4.83226,4.83226,0,0,1,4.82688-4.82649h47.25731a4.83226,4.83226,0,0,1,4.82688,4.82649v65.14444A4.83226,4.83226,0,0,1,369.52542,516.73978Z"
        transform="translate(-206.17014 -154.54318)"
        fill="#e6e6e6"
      />
      <path
        d="M455.70505,516.73978H408.44774a4.83226,4.83226,0,0,1-4.82688-4.82649V384.97968a4.83226,4.83226,0,0,1,4.82688-4.82649h47.25731a4.83226,4.83226,0,0,1,4.82688,4.82649V511.91329A4.83226,4.83226,0,0,1,455.70505,516.73978Z"
        transform="translate(-206.17014 -154.54318)"
        fill="#e6e6e6"
      />
      <path
        d="M541.88468,516.73978H494.62737a4.83226,4.83226,0,0,1-4.82688-4.82649V446.76885a4.83226,4.83226,0,0,1,4.82688-4.82649h47.25731a4.83226,4.83226,0,0,1,4.82688,4.82649v65.14444A4.83226,4.83226,0,0,1,541.88468,516.73978Z"
        transform="translate(-206.17014 -154.54318)"
        fill="#e6e6e6"
      />
      <path
        d="M628.06431,516.73978H580.807a4.72664,4.72664,0,0,1-4.82688-4.60784V360.37056a4.72664,4.72664,0,0,1,4.82688-4.60783h47.25731a4.72664,4.72664,0,0,1,4.82688,4.60783V512.13194A4.72664,4.72664,0,0,1,628.06431,516.73978Z"
        transform="translate(-206.17014 -154.54318)"
        fill="#e6e6e6"
      />
      <path
        d="M714.24394,516.73978H666.98663a4.83226,4.83226,0,0,1-4.82688-4.82649V316.68639a4.83226,4.83226,0,0,1,4.82688-4.82649h47.25731a4.83226,4.83226,0,0,1,4.82688,4.82649v195.2269A4.83226,4.83226,0,0,1,714.24394,516.73978Z"
        transform="translate(-206.17014 -154.54318)"
        fill="#f2f2f2"
      />
      <circle cx="139.72663" cy="258.13062" r="9.75618" fill="#3f3d56" />
      <circle cx="225.90626" cy="194.71542" r="9.75618" fill="#3f3d56" />
      <circle cx="312.08589" cy="258.13062" r="9.75618" fill="#3f3d56" />
      <circle cx="398.26552" cy="163.82084" r="9.75618" fill="#3f3d56" />
      <circle cx="484.44515" cy="128.04816" r="9.75618" fill="#3f3d56" />
      <polygon
        points="312.292 260.316 225.906 195.613 140.702 259.432 138.752 256.829 225.906 191.549 311.88 255.945 397.315 162.451 397.658 162.312 483.837 127.589 485.053 130.606 399.216 165.19 312.292 260.316"
        fill="#3f3d56"
      />
      <polygon
        points="604.996 574.714 590.317 574.713 583.333 518.093 604.999 518.094 604.996 574.714"
        fill="#ffb6b6"
      />
      <path
        d="M814.90974,743.48659l-47.33243-.00175v-.59868a18.4241,18.4241,0,0,1,18.4231-18.42281h.00117l28.909.00117Z"
        transform="translate(-206.17014 -154.54318)"
        fill="#2f2e41"
      />
      <path
        d="M758.70505,489.60686,767.03871,622.389l27.98117,93.46455,21.67845,1.56976L805.81248,603.51508l4.773-75.64658s22.627-16.8667,10.11616-37.16992Z"
        transform="translate(-206.17014 -154.54318)"
        fill="#2f2e41"
      />
      <polygon
        points="614.575 574.714 599.895 574.713 592.912 518.093 614.577 518.094 614.575 574.714"
        fill="#ffb6b6"
      />
      <path
        d="M824.4886,743.48659l-47.33243-.00175v-.59868a18.42409,18.42409,0,0,1,18.4231-18.42281h.00117l28.909.00117Z"
        transform="translate(-206.17014 -154.54318)"
        fill="#2f2e41"
      />
      <path
        d="M768.2839,489.60686,776.61757,622.389l27.98117,93.46455,21.67845,1.56976L815.39133,603.51508l4.77305-75.64658s22.627-16.8667,10.11616-37.16992Z"
        transform="translate(-206.17014 -154.54318)"
        fill="#2f2e41"
      />
      <path
        d="M813.4614,510.1689c-24.998,0-54.41981-15.27682-56.12493-16.17426l-.47415-.24964,57.37257-146.36577L842.649,333.95574a13.596,13.596,0,0,1,19.31966,13.79942L850.69318,448.909l-11.77011,52.3908-.12512.12277C832.30223,507.84084,823.21682,510.1689,813.4614,510.1689Z"
        transform="translate(-206.17014 -154.54318)"
        fill="#3f3d56"
      />
      <path
        d="M721.78115,413.27726a12.04035,12.04035,0,0,1,17.59049,5.6068l42.72367-2.33387-11.20993,19.2019-38.85251-.72758a12.1056,12.1056,0,0,1-10.25172-21.74725Z"
        transform="translate(-206.17014 -154.54318)"
        fill="#ffb6b6"
      />
      <path
        d="M806.094,443.335l-42.81545-1.09271.5525-28.32146,20.24573-6.444,33.20883-46.57765a21.4253,21.4253,0,1,1,34.165,25.83555Z"
        transform="translate(-206.17014 -154.54318)"
        fill="#3f3d56"
      />
      <circle cx="624.71343" cy="145.57016" r="28.44921" fill="#ffb6b6" />
      <path
        d="M794.891,276.40569a19.44515,19.44515,0,0,1,10.65651-5.59168c3.95126-.85011,8.28569-1.11353,11.44673-3.59207,3.59207-2.8617,5.17259-8.29767,9.57885-9.507a10.501,10.501,0,0,1,5.73532.455,37.118,37.118,0,0,1,17.96035,11.97357,15.37488,15.37488,0,0,0,4.13089,4.13089,29.93045,29.93045,0,0,1,2.84972,1.38894,7.759,7.759,0,0,1,2.32287,3.02931,29.44287,29.44287,0,0,1,2.05942,20.67834c-1.10154,4.083-3.0892,7.86665-4.26258,11.97357s-6.60024,11.9196-7.86944,9.97989-2.89758-3.74773-3.59207-5.98679c-1.35485-4.40429-.13131-8.83646-3.57729-11.89566-2.13133-1.89181-5.98679-3.161-7.43562-.71842-.5747.94592-.53882,2.14328-1.02971,3.12508-.96985,1.91578-3.7717,2.29894-5.62759,1.19736a8.633,8.633,0,0,1-3.52023-5.22046c-2.78986-9.43518-7.54333-15.37406-17.637-11.339-3.75972,1.50868-8.19,2.5264-11.80592-.05985C790.50869,287.02624,791.47854,280.28511,794.891,276.40569Z"
        transform="translate(-206.17014 -154.54318)"
        fill="#2f2e41"
      />
      <path
        d="M731.00694,532.30542H683.74962a4.83226,4.83226,0,0,1-4.82688-4.82649V332.252a4.83226,4.83226,0,0,1,4.82688-4.82648h47.25732a4.83226,4.83226,0,0,1,4.82688,4.82648V527.47893A4.83226,4.83226,0,0,1,731.00694,532.30542Z"
        transform="translate(-206.17014 -154.54318)"
        fill="#f2f2f2"
      />
      <path
        d="M720.58379,430.04025a12.04038,12.04038,0,0,1,17.5905,5.6068l42.72366-2.33387L769.688,452.51509l-38.85251-.72758a12.10561,12.10561,0,0,1-10.25172-21.74726Z"
        transform="translate(-206.17014 -154.54318)"
        fill="#ffb6b6"
      />
      <path
        d="M804.89662,460.098l-42.81545-1.0927.55249-28.32147,20.24574-6.444,33.20882-46.57766a21.4253,21.4253,0,1,1,34.165,25.83555Z"
        transform="translate(-206.17014 -154.54318)"
        fill="#3f3d56"
      />
      <path
        d="M991.95209,745.18877h-456.193a1.19736,1.19736,0,1,1,0-2.39471h456.193a1.19736,1.19736,0,1,1,0,2.39471Z"
        transform="translate(-206.17014 -154.54318)"
        fill="#cacaca"
      />
    </svg>
  );
};

export const ErrorPage = () => {
  return (
    <svg width="524.67001" height="418.27099" viewBox="0 0 524.67001 418.27099">
      <path
        d="M442.17403,400.47713c2.06599,.12871,3.20692-2.43846,1.64338-3.93389l-.1557-.61814c.0204-.04935,.04089-.09868,.06153-.14794,1.23211-2.94003,4.62545-4.33201,7.57137-3.11404,9.3142,3.85087-.51966,12.69986,.21957,18.68773,.25911,2.06671,8.35473,2.18034,7.89681,4.2086,4.30482-9.41207,6.56835-19.68889,6.56478-30.02306-.0009-2.59653-.14392-5.19297-.43543-7.78281-.23975-2.11845-.56985-4.22389-.9969-6.30999-2.30966-11.27639-7.30614-22.01572-14.51084-30.98461-3.46263-1.89129-1.35074-4.85018-3.09586-8.39544-.62694-1.27868-6.21792-1.30745-6.45092-2.70892,.25019,.03272,3.86434-3.721,2.6705-5.5767-.78555-1.22107-.54106-2.7763,.4681-3.82017,.09887-.1023,.19234-.2103,.27796-.32648,2.98093-4.04443,7.09003-3.33985,9.23695,2.15406,4.58304,2.31107,4.62871,6.14647,1.81834,9.83619-1.78798,2.34745-2.03264,5.52304-3.60129,8.03604,.16157,.20664,.32958,.40684,.49112,.61348,2.96237,3.79686,5.52482,7.87809,7.68524,12.16592-.61182-4.76599,.28705-10.50831,1.8215-14.21023,1.75933-4.24835,5.06953-7.8221,7.96883-11.49665,3.46275-4.38865,10.5104-2.39707,11.12286,3.15951,.00588,.05337,.0116,.10665,.01724,.16003-.42884,.24212-.84895,.49935-1.25929,.77094-2.33882,1.54808-1.52824,5.17442,1.24391,5.60071l.06278,.00965c-.1545,1.54372-5.63258,6.40679-6.01957,7.91187,3.70514,14.30838,.93282,16.19755-10.46624,16.43703l-.59825,.8522c1.08024,3.1058,1.94956,6.2861,2.60235,9.50743,.61462,2.99021,1.042,6.01282,1.28197,9.04845,.29847,3.82994,.27396,7.6795-.04769,11.50325l.01933-.13563c.81879-4.21143,3.1039-8.1457,6.42284-10.87249,4.94421-4.06436,11.93091-5.56281,17.2652-8.83022,2.56778-1.57285,5.85959,.45742,5.41241,3.4352l-.02177,.14262c-.79432,.32315-1.56922,.69808-2.31831,1.11814-.42921,.24237-.84965,.49978-1.26032,.77165-2.33916,1.54848-1.52796,5.1753,1.24498,5.60009l.06281,.00962c.0452,.00645,.08399,.01291,.12913,.0194-1.3617,3.23628-14.33553,7.80147-16.71149,10.39229-2.31031,12.49793-1.17531,12.12596-11.81075,8.49032h-.00647c-1.16085,5.06419-2.8578,10.01225-5.03931,14.72794l-18.0202,.00623c-.06471-.2002-.12288-.40688-.18109-.60712,1.66645,.10285,3.34571,.00534,4.98619-.29875-1.33757-1.64013-2.67509-3.29317-4.01266-4.93324-.0323-.03228-.05819-.06459-.08402-.09686l-.02036-.02517-1.85532-6.10724c.14644-1.35476,.38536-2.69828,.70958-4.02051l.00049-.00037v.00006Z"
        fill="#f2f2f2"
      />
      <path
        d="M251.74443,416.41995l-159.45702,.05516c-8.01074,.00277-15.18649-4.13684-19.19426-11.07295-2.00413-3.46855-3.00642-7.27337-3.00774-11.07904-.00132-3.80518,.99882-7.61119,3.00007-11.08063l79.67786-145.04905c4.00346-6.93937,11.17634-11.08346,19.18708-11.08623s15.18649,4.13635,19.19475,11.07295l79.78843,145.01196c1.99876,3.45927,2.99861,7.25971,2.99894,11.06293-.00015,3.80322-.99981,7.60874-3.00154,11.07868-4.00297,6.93889-11.17585,11.08346-19.1866,11.08623h.00002Zm-179.65463-22.09948c-.00026,3.46387,17.5953-4.00023,19.41817-.8451,3.64623,6.31026-6.50934,21.00225,.77874,20.99973,0,0,173.27016-3.828,176.91202-10.14078,1.82069-3.15639,2.73062-6.61911,2.72942-10.08102s-.91353-6.92351-2.73688-10.07864l-79.78845-145.01196c-3.63597-6.2922-10.16364-10.05801-17.45172-10.05549-7.28467,.00252-99.86105,161.74891-99.86132,165.21326h.00002Z"
        fill="#3f3d56"
      />
      <path
        d="M253.51521,414.41934c-1.99862,4.00069,91.61376,2.7712,92.72051,2.77082,0,0,26.3119-.58131,26.86492-1.53993,.27648-.47931,.41466-1.00515,.41448-1.53084s-.13873-1.05137-.4156-1.5305l-12.11626-22.02074c-.55215-.9555-1.54341-1.52736-2.65013-1.52698-.04608,.00002-.11394,.04093-.20168,.11933-16.16328,14.44385-36.0828,23.99237-57.75707,24.31469-23.047,.34272-46.73217,.6899-46.85919,.94416h.00002Z"
        fill="#3f3d56"
      />
      <path
        d="M0,417.0814c.00023,.66003,.53044,1.18982,1.19047,1.18959l522.28995-.18066c.65997-.00023,1.18982-.53038,1.18959-1.19041-.00023-.65997-.53044-1.18982-1.19041-1.18959l-522.28995,.18066c-.66003,.00023-1.18988,.53044-1.18965,1.19041Z"
        fill="#ccc"
      />
      <g>
        <polygon
          points="403.87773 411.30541 394.83299 411.30765 390.51828 376.42194 403.86746 376.41823 403.87773 411.30541"
          fill="#a0616a"
        />
        <path
          d="M372.88925,411.11096h0c-.28145,.4744-.42951,2.00528-.42932,2.55685h0c.00059,1.6954,1.37542,3.06935,3.07089,3.06876l28.01047-.00969c1.15659-.0004,2.09391-.93832,2.09351-2.09496l-.0004-1.16617s1.38444-3.50542-1.46987-7.82444c0,0-3.54448,3.38386-8.84444-1.91244l-1.56336-2.82981-11.30656,8.27506-6.26838,.77377c-1.3714,.16927-2.58738-.02532-3.29241,1.16307h-.00012Z"
          fill="#2f2e41"
        />
      </g>
      <g>
        <polygon
          points="369.19708 381.46752 360.62951 384.36642 345.36911 352.70019 358.01396 348.42131 369.19708 381.46752"
          fill="#a0616a"
        />
        <path
          d="M339.77867,391.20807h0c-.11468,.53956,.23535,2.03724,.41217,2.5597h0c.54355,1.60589,2.28601,2.46714,3.89196,1.92358l26.53193-8.98019c1.09554-.3708,1.68312-1.55951,1.31228-2.65512l-.37389-1.10461s.18882-3.76416-3.8984-6.94155c0,0-2.27401,4.34084-8.99107,1.02096l-2.38732-2.18005-8.0607,11.46034-5.69037,2.74062c-1.24494,.59958-2.45919,.80471-2.74651,2.15628l-.00009,.00003Z"
          fill="#2f2e41"
        />
      </g>
      <polygon
        points="355.22599 179.09003 337.68255 237.19081 316.97199 289.45207 349.76053 364.08569 361.91802 358.67731 347.37062 290.11706 377.87822 243.59436 392.11437 388.82623 404.27349 388.14652 420.76309 212.84336 423.11421 174.67566 355.22599 179.09003"
        fill="#2f2e41"
      />
      <path
        d="M408.20979,50.38513l-25.66813,4.73752-2.02258,11.48454-15.53439,7.43609-8.07702,84.4428s-13.50433,17.56819-2.69414,22.96862l68.9007-6.77904s3.37327-12.4903-.00473-13.67529-3.38832-31.01955-3.38832-31.01955l15.51573-61.36599-22.97048-8.09829-4.05664-10.13141Z"
        fill="#e6e6e6"
      />
      <circle cx="393.06995" cy="29.43589" r="20.7276" fill="#a0616a" />
      <path
        d="M406.79605,32.51227c-1.65401,.9055-.08471,5.22869-1.11848,5.60245-1.19492,.43202-5.55162-4.52715-5.60554-10.08176-.01633-1.68115,.37051-2.48839-.00155-4.48164-.48668-2.6073-1.98045-5.68253-3.36317-5.60089-.81965,.04839-1.62013,1.20723-1.67986,2.2414-.0837,1.44941,1.32419,2.01989,1.12139,2.80064-.38627,1.4871-6.29829,2.5138-8.40308,.00291-1.65013-1.9685-.38463-5.4247-1.12236-5.60167-.54378-.13045-1.12759,1.77241-3.35988,3.9226-.84103,.8101-2.09186,2.0149-2.80044,1.68159-1.02397-.48167-.28003-3.87624-.56157-3.92125-.23314-.03727-.37947,2.3487-1.67908,4.48223-1.66968,2.74103-5.11398,4.85374-6.72112,3.92377-.98466-.56978-1.06245-2.15606-1.12158-3.36084-.1245-2.53816-3.81308-8.37644-2.85882-11.09166,1.94221-5.5263,5.2701-1.63078,6.7752-3.47504,2.03756-2.49669,3.86572-1.15434,7.28133-3.92396,3.33668-2.70564,3.36577-5.42504,5.60011-5.604,2.01221-.16116,2.7278,1.98528,5.04242,1.67887,1.96079-.25957,2.38749-1.92436,3.92087-1.68198,1.40389,.2219,1.49646,1.68849,3.36201,2.23966,1.19101,.35188,1.45267-.15743,2.80103-.00097,2.80559,.32556,4.69002,2.88083,5.043,3.35949,1.36081,1.84526,.83282,2.62341,2.24236,4.48086,1.21555,1.6018,3.90913,.9216,4.92189,1.72162,3.30928,2.61409,4.73124,7.43497,4.75994,12.92962,.0201,3.8431-.48103,5.78482-1.59913,10.63564-.84901,3.6834-4.78175,8.44334-6.94987,10.5659-.58199,.56975-2.21351,2.167-3.36066,1.68178-1.08704-.45979-1.11995-2.52764-1.12139-2.80064-.0049-.93901,.24521-2.1009,2.23907-5.04263,2.09442-3.09006,2.92645-3.44271,2.79948-4.48262-.22445-1.83818-3.16424-3.52123-4.48263-2.79948h.00012Z"
        fill="#2f2e41"
      />
      <g>
        <path
          d="M334.49457,225.75979c-.64513,5.40264,1.61895,10.11513,5.05699,10.52567s6.7481-3.63632,7.39324-9.03898c.28242-2.36492,.00723-4.59754-.6797-6.39504l2.44642-22.92684-10.7834-.91891-1.26717,22.69891c-1.09088,1.58522-1.88401,3.69026-2.16639,6.05519h.00003Z"
          fill="#a0616a"
        />
        <path
          d="M365.49095,73.49769s-5.58664,.07946-9.28568,7.30383c-1.96565,3.83897-12.48211,75.62767-12.48211,75.62767l-9.68742,58.80847,16.50214,.08313,12.859-55.69302,10.81723-32.30088-8.72315-53.82921Z"
          fill="#e6e6e6"
        />
      </g>
      <path
        d="M411.92961,217.13028c-1.58023,5.20651-.17535,10.24237,3.13786,11.24797s7.28015-2.39987,8.86035-7.60638c.69172-2.27906,.81133-4.5254,.44941-6.41533l6.4191-22.14543-10.45641-2.79098-5.21815,22.12729c-1.35133,1.36996-2.50044,3.30383-3.19216,5.58289v-.00003Z"
        fill="#a0616a"
      />
      <path
        d="M423.41564,69.63219s8.10413-6.08248,14.86262,3.37246c6.75846,9.45495,9.48742,87.1388,9.48742,87.1388l-18.89796,47.96845-14.18755-4.72373,13.49008-58.7749-23.65861-44.57614,18.90403-30.40494h-.00003Z"
        fill="#e6e6e6"
      />
      <g>
        <circle cx="218.47958" cy="311.43145" r="73" fill="#6c63ff" />
        <g>
          <circle cx="218.49274" cy="349.47878" r="6.70264" fill="#fff" />
          <path
            d="M218.4641,266.68145c-.6157,4.0912,.48747,4.94727,.49357,22.58508,.0061,17.63782,3.66579,41.28574-.47148,41.28717s-5.65047-48.80276-20.01681-53.12218c-16.89088-5.07846,21.98785-23.99409,19.99471-10.75007Z"
            fill="#fff"
          />
        </g>
      </g>
      <path
        d="M120.50313,348.70219l-6.59532,13.93527c7.97328-5.71745,20.42715-10.64598,30.3376-13.28567-9.23403-4.46037-20.53313-11.65189-27.2835-18.77194l3.7934,14.72434c-44.47393-9.0585-76.41138-43.17661-76.4249-82.25924l-1.60648-.5527c.01412,40.82281,31.50971,76.96121,77.7792,86.20995Z"
        fill="#3f3d56"
      />
    </svg>
  );
};

export const FooterCity = () => {
  return (
    <svg
      version="1.2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 4600 215"
      width="4600"
      height="215"
    >
      <path
        fill="#37429a"
        d="m2397.8 241v-132.4h-13.9v22h-19l-7.9 8.3v-53.3h-21.4l-11.5-12h-70.7v48.4h-21.6v-17.7h-11.8v31.6h-11.4l-20.3-21.1h-29l-8.9 9.2h-10.6v55.8h-43.7l-35.5-36.9v-64.2l-11.8-12.4h-57.1l-10.8 11.3v70.6h-44.7v-63.1l-8.5-8.9v-13.1h-8v89.9h-41.6v-53.9l-18.6-19.3h-45.1v96.8h-26.8v-56.7h-40.1v-28.4l-7.4-7.8v36.7h-8v-38.5h-66.3v42.2h-17.5v-25h-8.7v25h-19.6v17.2h-8.7v-34.3h-11.3v134z"
      />
      <path
        fill="#151a3c"
        d="m2400 241.5h-803v-54.6h18.1v-34.4h13.5v15.1h12.4v-22.7l11.9-12.4 9.3 9.7v30.7h8.8v-81.8h9.3v-19.4h29v19.4h10.3v71.1h8.3v-17.3l17.6-18.3 18.1 18.9v16.7h9.8v44.1h12.5v-44.1l9.8-10.3 9.3 9.7h7.4v-16h6.9v-11.8h10.4l6.2-6.5h26.5l6.8-7h14.3l7.3 7.7h8.6v38.7l8.2-8.4v-46.2h8.6v45.8l7.2 7.4h8.6v-13.4h13v10.3h6.2v5.1h5.7l17.6-44.5h10.3v-14.5h32.9v-4.8h12.1l6.7 7v57.1h4.7v-10.3h15.3l17.9 18.7v9.6h14.4v-32.4h8.9v-37.7l6.4-6.7h19.1l5.4 5.7v32.2h11.5v-12.5h13.8v9.3l17.8-18.5h19.5v12.8h10.3v10.7h18.3l8.8-9.1h35v-28.9h6.2v-15.8h36.6v12.2l8.1 8.4v57.3h8.1v-43.5l16-16.7v-13.7h17.1v47.3h18.6v-12.6h25.7z"
      />
      <path
        fill="#6c77cb"
        d="m3197 234v-159.1h-20v22.4h-60.7v-55.6l-71.9-19.3h-30.9v84.6h-47.3v-37.5h-46.2v55.7h-42.2v-30h-53.5v-72.8h-21.5v19.3h-13.4v-19.3h-24.7v86.7h-38v-67.4h-26.8v41.7h-15.4v-32.1h-36v45h-47.3v-40.2h-18.5v35.9h-35.9v-35.9h-54.5v16.6l-29.3-30.5h-37.9v42.7h-5.2v-19.7h-20.7v168.8z"
      />
      <path
        fill="#37429a"
        d="m3194.8 234v-132.4h-13.9v22h-19l-7.9 8.3v-53.3h-21.4l-11.5-12h-70.7v48.4h-21.6v-17.7h-11.8v31.6h-11.4l-20.3-21.1h-29l-8.9 9.2h-10.6v55.8h-43.7l-35.5-36.9v-64.2l-11.8-12.4h-57.1l-10.8 11.3v70.6h-44.7v-63.1l-8.5-8.9v-13.1h-8v89.9h-41.6v-53.9l-18.6-19.3h-45.1v96.8h-26.8v-56.7h-40.1v-28.4l-7.4-7.8v36.7h-8v-38.5h-66.3v42.2h-17.5v-25h-8.7v25h-19.6v17.2h-8.7v-34.3h-11.3v134z"
      />
      <path
        fill="#151a3c"
        d="m3197 234.5h-803v-54.6h18.1v-34.4h13.5v15.1h12.4v-22.7l11.9-12.4 9.3 9.7v30.7h8.8v-81.8h9.3v-19.4h29v19.4h10.3v71.1h8.3v-17.3l17.6-18.3 18.1 18.9v16.7h9.8v44.1h12.5v-44.1l9.8-10.3 9.3 9.7h7.4v-16h6.9v-11.8h10.4l6.2-6.5h26.5l6.8-7h14.3l7.3 7.7h8.6v38.7l8.2-8.4v-46.2h8.6v45.8l7.2 7.4h8.6v-13.4h13v10.3h6.2v5.1h5.7l17.6-44.5h10.3v-14.5h32.9v-4.8h12.1l6.7 7v57.1h4.7v-10.3h15.3l17.9 18.7v9.6h14.4v-32.4h8.9v-37.7l6.4-6.7h19.1l5.4 5.7v32.2h11.5v-12.5h13.8v9.3l17.8-18.5h19.5v12.8h10.3v10.7h18.3l8.8-9.1h35v-28.9h6.2v-15.8h36.6v12.2l8.1 8.4v57.3h8.1v-43.5l16-16.7v-13.7h17.1v47.3h18.6v-12.6h25.7z"
      />
      <path
        fill="#6c77cb"
        d="m800 238v-159.1h20v22.4h60.7v-55.6l71.9-19.3h30.9v84.6h47.3v-37.5h46.2v55.7h42.2v-30h53.5v-72.8h21.5v19.3h13.4v-19.3h24.7v86.7h38v-67.4h26.8v41.7h15.4v-32.1h36v45h47.3v-40.2h18.5v35.9h35.9v-35.9h54.5v16.6l29.3-30.5h37.9v42.7h5.2v-19.7h20.7v168.8z"
      />
      <path
        fill="#37429a"
        d="m802.2 238v-132.4h13.9v22h19l7.9 8.3v-53.3h21.4l11.5-12h70.7v48.4h21.6v-17.7h11.8v31.6h11.4l20.3-21.1h29l8.9 9.2h10.6v55.8h43.7l35.5-36.9v-64.2l11.8-12.4h57.1l10.8 11.3v70.6h44.7v-63.1l8.5-8.9v-13.1h8v89.9h41.6v-53.9l18.6-19.3h45.1v96.8h26.8v-56.7h40.1v-28.4l7.4-7.8v36.7h8v-38.5h66.3v42.2h17.5v-25h8.7v25h19.6v17.2h8.7v-34.3h11.3v134z"
      />
      <path
        fill="#151a3c"
        d="m800 238.4h802v-54.5h-18.1v-34.4h-13.4v15h-12.4v-22.6l-11.9-12.3-9.3 9.7v30.6h-8.8v-81.7h-9.3v-19.4h-28.9v19.4h-10.4v71h-8.2v-17.3l-17.6-18.2-18.1 18.8v16.7h-9.8v44.1h-12.4v-44.1l-9.8-10.3-9.3 9.7h-7.5v-15.9h-6.8v-11.9h-10.4l-6.2-6.4h-26.5l-6.7-7h-14.3l-7.3 7.6h-8.7v38.7l-8.1-8.4v-46.2h-8.7v45.8l-7.1 7.4h-8.6v-13.4h-12.9v10.3h-6.2v5.1h-5.7l-17.6-44.4h-10.3v-14.5h-32.8v-4.9h-12.2l-6.7 7v57h-4.7v-10.2h-15.2l-18 18.7v9.6h-14.3v-32.4h-8.9v-37.7l-6.3-6.6h-19.2l-5.4 5.7v32.1h-11.4v-12.5h-13.8v9.3l-17.8-18.5h-19.4v12.8h-10.4v10.7h-18.2l-8.8-9.1h-35v-28.9h-6.2v-15.8h-36.5v12.2l-8.1 8.5v57.2h-8.1v-43.4l-16-16.7v-13.7h-17.1v47.2h-18.6v-12.5h-25.6z"
      />
      <path
        fill="#6c77cb"
        d="m0 238v-159.1h20v22.4h60.7v-55.6l72-19.3h30.8v84.6h47.3v-37.5h46.3v55.7h42.1v-30h53.5v-72.8h21.6v19.3h13.3v-19.3h24.7v86.7h38.1v-67.4h26.7v41.7h15.4v-32.1h36v45h47.3v-40.2h18.5v35.9h36v-35.9h54.5v16.6l29.3-30.5h37.8v42.7h5.2v-19.7h20.7v168.8z"
      />
      <path
        fill="#37429a"
        d="m2.2 238v-132.4h13.9v22h19l8 8.3v-53.3h21.3l11.6-12h70.7v48.4h21.6v-17.7h11.8v31.6h11.3l20.3-21.1h29l8.9 9.2h10.7v55.8h43.7l35.4-36.9v-64.2l11.9-12.4h57l10.8 11.3v70.6h44.7v-63.1l8.5-8.9v-13.1h8v89.9h41.6v-53.9l18.6-19.3h45.2v96.8h26.7v-56.7h40.1v-28.4l7.5-7.8v36.7h7.9v-38.5h66.3v42.2h17.5v-25h8.8v25h19.5v17.2h8.7v-34.3h11.3v134z"
      />
      <path
        fill="#151a3c"
        d="m0.1 238h807.7v-54.9h-18.2v-34.7h-13.5v15.2h-12.5v-22.7l-12-12.5-9.4 9.8v30.8h-8.8v-82.3h-9.4v-19.5h-29.1v19.5h-10.4v71.5h-8.4v-17.3l-17.7-18.5-18.2 19v16.8h-9.9v44.4h-12.4v-44.4l-9.9-10.3-9.4 9.8h-7.5v-16.1h-6.9v-11.9h-10.4l-6.3-6.5h-26.7l-6.7-7.1h-14.4l-7.4 7.7h-8.7v39l-8.2-8.5v-46.5h-8.7v46.1l-7.2 7.4h-8.7v-13.4h-13v10.3h-6.2v5.1h-5.8l-17.7-44.6h-10.4v-14.7h-33v-4.9h-12.2l-6.8 7.1v57.4h-4.7v-10.3h-15.3l-18.1 18.9v9.6h-14.5v-32.6h-8.9v-38l-6.4-6.6h-19.3l-5.4 5.7v32.4h-11.6v-12.7h-13.9v9.4l-17.8-18.6h-19.6v12.8h-10.4v10.9h-18.4l-8.9-9.2h-35.2v-29.1h-6.2v-15.9h-36.8v12.3l-8.2 8.5v57.6h-8.1v-43.7l-16.2-16.8v-13.8h-17.1v47.5h-18.8v-12.6h-25.8z"
      />
      <path
        fill="#6c77cb"
        d="m3196 229v-159.1h20v22.4h60.7v-55.6l72-19.3h30.8v84.6h47.3v-37.5h46.3v55.7h42.1v-30h53.5v-72.8h21.6v19.3h13.3v-19.3h24.7v86.7h38.1v-67.4h26.7v41.7h15.4v-32.1h36v45h47.3v-40.2h18.5v35.9h36v-35.9h54.5v16.6l29.3-30.5h37.8v42.7h5.2v-19.7h20.7v168.8z"
      />
      <path
        fill="#37429a"
        d="m3172.2 229v-132.4h13.9v22h19l8 8.3v-53.3h21.3l11.6-12h70.7v48.4h21.6v-17.7h11.8v31.6h11.3l20.3-21.1h29l8.9 9.2h10.7v55.8h43.7l35.4-36.9v-64.2l11.9-12.4h57l10.8 11.3v70.6h44.7v-63.1l8.5-8.9v-13.1h8v89.9h41.6v-53.9l18.6-19.3h45.2v96.8h26.7v-56.7h40.1v-28.4l7.5-7.8v36.7h7.9v-38.5h66.3v42.2h17.5v-25h8.8v25h19.5v17.2h8.7v-34.3h11.3v134z"
      />
      <path
        fill="#151a3c"
        d="m3172 231.5h831.8v-56.5h-18.7v-35.7h-14v15.6h-12.8v-23.4l-12.4-12.8-9.6 10v31.8h-9.1v-84.8h-9.7v-20.1h-30v20.1h-10.7v73.7h-8.6v-17.9l-18.2-19-18.8 19.6v17.3h-10.1v45.7h-12.9v-45.7l-10.2-10.6-9.6 10h-7.7v-16.5h-7.2v-12.3h-10.7l-6.4-6.7h-27.5l-7-7.3h-14.8l-7.6 7.9h-9v40.2l-8.4-8.8v-47.8h-9v47.4l-7.3 7.7h-9v-13.8h-13.4v10.6h-6.4v5.3h-5.9l-18.3-46.1h-10.7v-15h-34v-5h-12.6l-7 7.2v59.1h-4.8v-10.6h-15.8l-18.6 19.4v9.9h-14.9v-33.5h-9.2v-39.1l-6.6-6.9h-19.9l-5.6 5.9v33.4h-11.9v-13h-14.3v9.6l-18.4-19.1h-20.1v13.2h-10.8v11.1h-18.9l-9.1-9.5h-36.3v-29.9h-6.4v-16.4h-37.9v12.7l-8.4 8.7v59.4h-8.4v-45.1l-16.6-17.2v-14.3h-17.7v49h-19.3v-13h-26.6z"
      />
      <path
        fill="#6c77cb"
        d="m4013 212v-159.1h20v22.4h60.7v-55.6l72-19.3h30.8v84.6h47.3v-37.5h46.3v55.7h42.1v-30h53.5v-72.8h21.6v19.3h13.3v-19.3h24.7v86.7h38.1v-67.4h26.7v41.7h15.4v-32.1h36v45h47.3v-40.2h18.5v35.9h36v-35.9h54.5v16.6l29.3-30.5h37.8v42.7h5.2v-19.7h20.7v168.8z"
      />
      <path
        fill="#37429a"
        d="m3989.2 212v-132.4h13.9v22h19l8 8.3v-53.3h21.3l11.6-12h70.7v48.4h21.6v-17.7h11.8v31.6h11.3l20.3-21.1h29l8.9 9.2h10.7v55.8h43.7l35.4-36.9v-64.2l11.9-12.4h57l10.8 11.3v70.6h44.7v-63.1l8.5-8.9v-13.1h8v89.9h41.6v-53.9l18.6-19.3h45.2v96.8h26.7v-56.7h40.1v-28.4l7.5-7.8v36.7h7.9v-38.5h66.3v42.2h17.5v-25h8.8v25h19.5v17.2h8.7v-34.3h11.3v134z"
      />
      <path
        fill="#151a3c"
        d="m3989 214.5h831.8v-56.5h-18.7v-35.7h-14v15.6h-12.8v-23.4l-12.4-12.8-9.6 10v31.8h-9.1v-84.8h-9.7v-20.1h-30v20.1h-10.7v73.7h-8.6v-17.9l-18.2-19-18.8 19.6v17.3h-10.1v45.7h-12.9v-45.7l-10.2-10.6-9.6 10h-7.7v-16.5h-7.2v-12.3h-10.7l-6.4-6.7h-27.5l-7-7.3h-14.8l-7.6 7.9h-9v40.2l-8.4-8.8v-47.8h-9v47.4l-7.3 7.7h-9v-13.8h-13.4v10.6h-6.4v5.3h-5.9l-18.3-46.1h-10.7v-15h-34v-5h-12.6l-7 7.2v59.1h-4.8v-10.6h-15.8l-18.6 19.4v9.9h-14.9v-33.5h-9.2v-39.1l-6.6-6.9h-19.9l-5.6 5.9v33.4h-11.9v-13h-14.3v9.6l-18.4-19.1h-20.1v13.2h-10.8v11.1h-18.9l-9.1-9.5h-36.3v-29.9h-6.4v-16.4h-37.9v12.7l-8.4 8.7v59.4h-8.4v-45.1l-16.6-17.2v-14.3h-17.7v49h-19.3v-13h-26.6z"
      />
      <g id="Layer">
        <path
          fill="#6c77cb"
          d="m2400 241v-159.1h-20v22.4h-60.7v-55.6l-71.9-19.3h-30.9v84.6h-47.3v-37.5h-46.2v55.7h-42.2v-30h-53.5v-72.8h-21.5v19.3h-13.4v-19.3h-24.7v86.7h-38v-67.4h-26.8v41.7h-15.4v-32.1h-36v45h-47.3v-40.2h-18.5v35.9h-35.9v-35.9h-54.5v16.6l-29.3-30.5h-37.9v42.7h-5.2v-19.7h-20.7v168.8z"
        />
        <path
          fill="#37429a"
          d="m2397.8 241v-132.4h-13.9v22h-19l-7.9 8.3v-53.3h-21.4l-11.5-12h-70.7v48.4h-21.6v-17.7h-11.8v31.6h-11.4l-20.3-21.1h-29l-8.9 9.2h-10.6v55.8h-43.7l-35.5-36.9v-64.2l-11.8-12.4h-57.1l-10.8 11.3v70.6h-44.7v-63.1l-8.5-8.9v-13.1h-8v89.9h-41.6v-53.9l-18.6-19.3h-45.1v96.8h-26.8v-56.7h-40.1v-28.4l-7.4-7.8v36.7h-8v-38.5h-66.3v42.2h-17.5v-25h-8.7v25h-19.6v17.2h-8.7v-34.3h-11.3v134z"
        />
        <path
          fill="#151a3c"
          d="m2400 241.5h-803v-54.6h18.1v-34.4h13.5v15.1h12.4v-22.7l11.9-12.4 9.3 9.7v30.7h8.8v-81.8h9.3v-19.4h29v19.4h10.3v71.1h8.3v-17.3l17.6-18.3 18.1 18.9v16.7h9.8v44.1h12.5v-44.1l9.8-10.3 9.3 9.7h7.4v-16h6.9v-11.8h10.4l6.2-6.5h26.5l6.8-7h14.3l7.3 7.7h8.6v38.7l8.2-8.4v-46.2h8.6v45.8l7.2 7.4h8.6v-13.4h13v10.3h6.2v5.1h5.7l17.6-44.5h10.3v-14.5h32.9v-4.8h12.1l6.7 7v57.1h4.7v-10.3h15.3l17.9 18.7v9.6h14.4v-32.4h8.9v-37.7l6.4-6.7h19.1l5.4 5.7v32.2h11.5v-12.5h13.8v9.3l17.8-18.5h19.5v12.8h10.3v10.7h18.3l8.8-9.1h35v-28.9h6.2v-15.8h36.6v12.2l8.1 8.4v57.3h8.1v-43.5l16-16.7v-13.7h17.1v47.3h18.6v-12.6h25.7z"
        />
        <path
          fill="#6c77cb"
          d="m3197 234v-159.1h-20v22.4h-60.7v-55.6l-71.9-19.3h-30.9v84.6h-47.3v-37.5h-46.2v55.7h-42.2v-30h-53.5v-72.8h-21.5v19.3h-13.4v-19.3h-24.7v86.7h-38v-67.4h-26.8v41.7h-15.4v-32.1h-36v45h-47.3v-40.2h-18.5v35.9h-35.9v-35.9h-54.5v16.6l-29.3-30.5h-37.9v42.7h-5.2v-19.7h-20.7v168.8z"
        />
        <path
          fill="#37429a"
          d="m3194.8 234v-132.4h-13.9v22h-19l-7.9 8.3v-53.3h-21.4l-11.5-12h-70.7v48.4h-21.6v-17.7h-11.8v31.6h-11.4l-20.3-21.1h-29l-8.9 9.2h-10.6v55.8h-43.7l-35.5-36.9v-64.2l-11.8-12.4h-57.1l-10.8 11.3v70.6h-44.7v-63.1l-8.5-8.9v-13.1h-8v89.9h-41.6v-53.9l-18.6-19.3h-45.1v96.8h-26.8v-56.7h-40.1v-28.4l-7.4-7.8v36.7h-8v-38.5h-66.3v42.2h-17.5v-25h-8.7v25h-19.6v17.2h-8.7v-34.3h-11.3v134z"
        />
        <path
          fill="#151a3c"
          d="m3197 234.5h-803v-54.6h18.1v-34.4h13.5v15.1h12.4v-22.7l11.9-12.4 9.3 9.7v30.7h8.8v-81.8h9.3v-19.4h29v19.4h10.3v71.1h8.3v-17.3l17.6-18.3 18.1 18.9v16.7h9.8v44.1h12.5v-44.1l9.8-10.3 9.3 9.7h7.4v-16h6.9v-11.8h10.4l6.2-6.5h26.5l6.8-7h14.3l7.3 7.7h8.6v38.7l8.2-8.4v-46.2h8.6v45.8l7.2 7.4h8.6v-13.4h13v10.3h6.2v5.1h5.7l17.6-44.5h10.3v-14.5h32.9v-4.8h12.1l6.7 7v57.1h4.7v-10.3h15.3l17.9 18.7v9.6h14.4v-32.4h8.9v-37.7l6.4-6.7h19.1l5.4 5.7v32.2h11.5v-12.5h13.8v9.3l17.8-18.5h19.5v12.8h10.3v10.7h18.3l8.8-9.1h35v-28.9h6.2v-15.8h36.6v12.2l8.1 8.4v57.3h8.1v-43.5l16-16.7v-13.7h17.1v47.3h18.6v-12.6h25.7z"
        />
      </g>
    </svg>
  );
};

export const Lost = () => {
  return (
    <svg width={885.201} height={708.317} data-name="Layer 1">
      <path
        fill="#f0f0f0"
        d="M148.558 708.135s-12.753-31.391 25.505-54.934Z"
        data-name="Path 482"
      />
      <path
        fill="#f0f0f0"
        d="M132.874 707.564s-3.89-22.374-34-22.182Z"
        data-name="Path 483"
      />
      <path
        fill="#f0f0f0"
        d="M575.558 708.135s-12.753-31.391 25.505-54.934Z"
        data-name="Path 482"
      />
      <path
        fill="#f0f0f0"
        d="M559.874 707.564s-3.89-22.374-34-22.182Z"
        data-name="Path 483"
      />
      <circle cx={565.054} cy={394.031} r={110.853} fill="#f0f0f0" />
      <path
        fill="#f0f0f0"
        d="M565.358 394.03h.305l5.482 314.287h-11.573l5.786-314.287z"
      />
      <circle cx={803.054} cy={479.085} r={80.853} fill="#f0f0f0" />
      <path
        fill="#f0f0f0"
        d="M803.276 479.085h.222l3.998 229.232h-8.441l4.221-229.232z"
      />
      <path
        fill="#ffb6b6"
        d="M355.328 479.907a10.664 10.664 0 0 0 9-13.652l30.734-22.168-18.409-6.992-26.364 22.123a10.721 10.721 0 0 0 5.04 20.689ZM332.796 697.353l-9.759-.001-4.643-37.642h14.404l-.002 37.643z"
      />
      <path
        fill="#2f2e41"
        d="m335.285 706.813-31.468-.001v-.398a12.249 12.249 0 0 1 12.248-12.248h19.22Z"
      />
      <path
        fill="#ffb6b6"
        d="m258.253 697.353-9.759-.001-4.642-37.642h14.403l-.002 37.643z"
      />
      <path
        fill="#2f2e41"
        d="m260.742 706.813-31.467-.001v-.398a12.249 12.249 0 0 1 12.248-12.248h19.22ZM265.791 488.031l-20.682 113.104-7.234 89.838 23.486-1.155 13.369-87.24 33.23-75.96 9.89 162.99 21.62.07 11.633-206.171-85.312 4.524z"
      />
      <path
        fill="#37429a"
        d="m353.75 358.573-28.988-11.534-33.257 3.805-28.192 15.585s8.624 108.158-3.877 133.528c0 0 10.016 13.873 50.826 10.487 0 0 39.754-5.025 40.739-18.06s1.193-36.737 1.193-36.737l13.8-47.551Z"
      />
      <path
        fill="#37429a"
        d="m274.644 368.511-11.331-2.082s-12.058 5.287-11.934 21.04-21.301 68.571 4.332 70.786 18.933-37.454 18.933-37.454ZM344.556 365.284l9.194-6.71s14.038 3.17 19.23 14.47c0 0 57.566 41.75 41.732 57.584s-48.11 35.322-48.11 35.322l-11.95-13.531 29.649-26.86-24.323-22.158Z"
      />
      <path
        fill="#ffb6b6"
        d="M329.856 317.051a23.8 23.8 0 0 1-47.6 0v-.913a23.8 23.8 0 0 1 47.581.913Z"
      />
      <path
        fill="#2f2e41"
        d="M309.674 313.215c1.522-.25 3.172-.487 4.537.213 2.965 1.516 2.283 5.816 3.903 8.654.64 1.126 1.675 2.046 2.101 3.264s.165 2.74.835 3.916c.968 1.699 3.593 1.949 5.316.938a8.455 8.455 0 0 0 3.337-4.708c.573-1.62 1.054-3.41 2.436-4.47a5.164 5.164 0 0 0 1.334-1.09 3.289 3.289 0 0 0 .317-1.863c0-4.117-.64-7.308.292-11.297 1.492-6.431 2.856-9.61-1.87-14.379a16.351 16.351 0 0 0-8.903-4.555c-3.045-.5-7.527 3.752-10.609 3.654-7.837-.31-14.451-7.57-21.923-5.225a15.42 15.42 0 0 0-8.051 5.926c-3.654 5.383-3.325 7.466-2.796 13.89a2.375 2.375 0 0 0 .408 1.37c.274.33.719.506.987.841a2.077 2.077 0 0 1 .304 1.498 10.078 10.078 0 0 1-.724 3.045 1.254 1.254 0 0 0-.11 1.097 1.108 1.108 0 0 0 .61.414c3.044 1.096 6.333-1.017 9.59-.963s6.353 2.235 9.714 1.76c2.966-.456 5.974-1.437 8.965-1.93Z"
      />
      <path
        fill="#fff"
        d="M309.516 445.525a2.839 2.839 0 0 1-.63.162l-26.426 3.689a2.844 2.844 0 0 1-3.062-1.804l-22.747-59.191a2.856 2.856 0 0 1 2.044-3.813l24.852-5.546a2.27 2.27 0 0 0 .552-.201l24.172-12.638a2.83 2.83 0 0 1 .587-.23l26.602-7.09a2.85 2.85 0 0 1 3.402 1.734l19.834 51.611a2.842 2.842 0 0 1-.375 2.73l-6.86 9.212a2.852 2.852 0 0 1-1.266.96l-14.99 5.762a2.255 2.255 0 0 0-.312.148l-24.98 14.317a2.856 2.856 0 0 1-.397.188Z"
      />
      <path
        fill="#e4e4e4"
        d="m321.811 366.753-3.378.9-8.952 2.388-.016.004-12.255 6.408-4.549 2.379h-.002l-6.83 3.572-.188.042-7.096 1.582-3.43.767-13.988 3.122 21.96 57.14 14.414-2.011 3.535-.494 7.533-1.053.087-.011 24.207-13.874 14.728-5.66 6.725-9.03-19.116-49.74Z"
      />
      <path
        fill="#fff"
        d="m265.527 399.365 72.824-27.987 1.246 3.245-72.823 27.987zM269.684 410.182l72.824-27.987 1.247 3.245-72.824 27.987zM278.081 432.032l72.824-27.987 1.247 3.245-72.824 27.987z"
      />
      <path
        fill="#fff"
        d="m321.811 366.753 21.802 56.73-3.245 1.247-21.935-57.076 3.378-.901zM297.21 376.453l-4.477 12.457-1.552 4.32-3.621 10.082-.776 2.155-.777 2.166-1.022 2.843-7.339 20.425-1.908-4.965 5.984-16.656 1.354-3.771.198-.55 1.601-4.459 2.02-5.622 1.553-4.322 4.211-11.723.002-.001 4.549-2.379z"
      />
      <path
        fill="#fff"
        d="m278.545 384.028 22.49 58.524-3.534.494-22.386-58.251 3.43-.767z"
      />
      <circle cx={273.731} cy={429.715} r={10.353} fill="#ffb6b6" />
      <circle cx={701.225} cy={183.976} r={183.976} fill="#e4e4e4" />
      <path
        d="M994.466 156.936A183.99 183.99 0 0 1 687.91 351.651a183.992 183.992 0 1 0 306.557-194.715Z"
        opacity={0.1}
        style={{
          isolation: "isolate",
        }}
        transform="translate(-157.4 -95.842)"
      />
      <path
        fill="#e4e4e4"
        d="M700.72 183.975h-.506l-9.098 521.602h19.207l-9.603-521.602z"
      />
      <path
        fill="#cacaca"
        d="M835 707.802H1a1 1 0 0 1 0-2h834a1 1 0 0 1 0 2Z"
      />
    </svg>
  );
};

const Icon = ({ icon }) => {
  const selectedIcon = {
    cup: <Cup />,
    lost: <Lost />,
    viber: <Viber />,
    gmail: <Gmail />,
    heart: <Heart />,
    404: <ErrorPage />,
    filter: <Filter />,
    quotes: <Quotes />,
    twitter: <Twitter />,
    youtube: <Youtube />,
    search: <SearchBar />,
    location: <Location />,
    whatsapp: <WhatsApp />,
    facebook: <Facebook />,
    arrowTop: <ArrowTop />,
    openQuote: <OpenQuote />,
    instagram: <Instagram />,
    arrowDown: <ArrowDown />,
    arrowLeft: <ArrowLeft />,
    closeQuote: <CloseQuote />,
    arrowRight: <ArrowRight />,
    footerCity: <FooterCity />,
    scrollMouse: <ScrollMouse />,
    locationMap: <LocationMap />,
    heartRemove: <HeartRemove />,
    notFoundPage: <NotFoundPage />,
    squarePattern: <SquarePattern />,
    contactFooter: <ContactFooter />,
    timeManagement: <TimeManagement />,
    contactContent: <ContactContent />,
    instagramVector: <InstagramVector />,
    resultIlustration: <ResultIlustration />,
    missionIlustration: <MissionIlustration />,
  };

  return <>{selectedIcon[icon]}</>;
};

export default Icon;
